import { b as Bt, g as Ee, a as zt, d as Fe, c as Yt, s as dt } from "./index-Dvb-FM3N.js";
import { r as xr, l as be } from "./index-CERo1xtz.js";
import { l as lr } from "./lodash-Ciu5ZM82.js";
import { secret_store as Ct } from "ddc";
import { c as Ne, a as pr } from "./_commonjsHelpers-Dn0DSpot.js";
import { Verification as yr } from "sgx-ias-verifier";
import Vt from "./config.js";
import { Sigma as br } from "./authentication.js";
function wr(x) {
  throw new Error('Could not dynamically require "' + x + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Xt = { exports: {} };
(function(x) {
  (function(a) {
    var s = function(t) {
      var n, r = new Float64Array(16);
      if (t)
        for (n = 0; n < t.length; n++)
          r[n] = t[n];
      return r;
    }, b = function() {
      throw new Error("no PRNG");
    }, v = new Uint8Array(16), U = new Uint8Array(32);
    U[0] = 9;
    var D = s(), O = s([1]), H = s([56129, 1]), ce = s([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), ye = s([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), le = s([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), we = s([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), Ce = s([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function Ue(t, n, r, e) {
      t[n] = r >> 24 & 255, t[n + 1] = r >> 16 & 255, t[n + 2] = r >> 8 & 255, t[n + 3] = r & 255, t[n + 4] = e >> 24 & 255, t[n + 5] = e >> 16 & 255, t[n + 6] = e >> 8 & 255, t[n + 7] = e & 255;
    }
    function oe(t, n, r, e, f) {
      var i, c = 0;
      for (i = 0; i < f; i++)
        c |= t[n + i] ^ r[e + i];
      return (1 & c - 1 >>> 8) - 1;
    }
    function Oe(t, n, r, e) {
      return oe(t, n, r, e, 16);
    }
    function Le(t, n, r, e) {
      return oe(t, n, r, e, 32);
    }
    function bt(t, n, r, e) {
      for (var f = e[0] & 255 | (e[1] & 255) << 8 | (e[2] & 255) << 16 | (e[3] & 255) << 24, i = r[0] & 255 | (r[1] & 255) << 8 | (r[2] & 255) << 16 | (r[3] & 255) << 24, c = r[4] & 255 | (r[5] & 255) << 8 | (r[6] & 255) << 16 | (r[7] & 255) << 24, p = r[8] & 255 | (r[9] & 255) << 8 | (r[10] & 255) << 16 | (r[11] & 255) << 24, A = r[12] & 255 | (r[13] & 255) << 8 | (r[14] & 255) << 16 | (r[15] & 255) << 24, q = e[4] & 255 | (e[5] & 255) << 8 | (e[6] & 255) << 16 | (e[7] & 255) << 24, _ = n[0] & 255 | (n[1] & 255) << 8 | (n[2] & 255) << 16 | (n[3] & 255) << 24, Q = n[4] & 255 | (n[5] & 255) << 8 | (n[6] & 255) << 16 | (n[7] & 255) << 24, R = n[8] & 255 | (n[9] & 255) << 8 | (n[10] & 255) << 16 | (n[11] & 255) << 24, P = n[12] & 255 | (n[13] & 255) << 8 | (n[14] & 255) << 16 | (n[15] & 255) << 24, M = e[8] & 255 | (e[9] & 255) << 8 | (e[10] & 255) << 16 | (e[11] & 255) << 24, F = r[16] & 255 | (r[17] & 255) << 8 | (r[18] & 255) << 16 | (r[19] & 255) << 24, k = r[20] & 255 | (r[21] & 255) << 8 | (r[22] & 255) << 16 | (r[23] & 255) << 24, L = r[24] & 255 | (r[25] & 255) << 8 | (r[26] & 255) << 16 | (r[27] & 255) << 24, G = r[28] & 255 | (r[29] & 255) << 8 | (r[30] & 255) << 16 | (r[31] & 255) << 24, j = e[12] & 255 | (e[13] & 255) << 8 | (e[14] & 255) << 16 | (e[15] & 255) << 24, T = f, B = i, E = c, C = p, $ = A, S = q, u = _, d = Q, w = R, l = P, y = M, g = F, I = k, N = L, z = G, K = j, o, V = 0; V < 20; V += 2)
        o = T + I | 0, $ ^= o << 7 | o >>> 25, o = $ + T | 0, w ^= o << 9 | o >>> 23, o = w + $ | 0, I ^= o << 13 | o >>> 19, o = I + w | 0, T ^= o << 18 | o >>> 14, o = S + B | 0, l ^= o << 7 | o >>> 25, o = l + S | 0, N ^= o << 9 | o >>> 23, o = N + l | 0, B ^= o << 13 | o >>> 19, o = B + N | 0, S ^= o << 18 | o >>> 14, o = y + u | 0, z ^= o << 7 | o >>> 25, o = z + y | 0, E ^= o << 9 | o >>> 23, o = E + z | 0, u ^= o << 13 | o >>> 19, o = u + E | 0, y ^= o << 18 | o >>> 14, o = K + g | 0, C ^= o << 7 | o >>> 25, o = C + K | 0, d ^= o << 9 | o >>> 23, o = d + C | 0, g ^= o << 13 | o >>> 19, o = g + d | 0, K ^= o << 18 | o >>> 14, o = T + C | 0, B ^= o << 7 | o >>> 25, o = B + T | 0, E ^= o << 9 | o >>> 23, o = E + B | 0, C ^= o << 13 | o >>> 19, o = C + E | 0, T ^= o << 18 | o >>> 14, o = S + $ | 0, u ^= o << 7 | o >>> 25, o = u + S | 0, d ^= o << 9 | o >>> 23, o = d + u | 0, $ ^= o << 13 | o >>> 19, o = $ + d | 0, S ^= o << 18 | o >>> 14, o = y + l | 0, g ^= o << 7 | o >>> 25, o = g + y | 0, w ^= o << 9 | o >>> 23, o = w + g | 0, l ^= o << 13 | o >>> 19, o = l + w | 0, y ^= o << 18 | o >>> 14, o = K + z | 0, I ^= o << 7 | o >>> 25, o = I + K | 0, N ^= o << 9 | o >>> 23, o = N + I | 0, z ^= o << 13 | o >>> 19, o = z + N | 0, K ^= o << 18 | o >>> 14;
      T = T + f | 0, B = B + i | 0, E = E + c | 0, C = C + p | 0, $ = $ + A | 0, S = S + q | 0, u = u + _ | 0, d = d + Q | 0, w = w + R | 0, l = l + P | 0, y = y + M | 0, g = g + F | 0, I = I + k | 0, N = N + L | 0, z = z + G | 0, K = K + j | 0, t[0] = T >>> 0 & 255, t[1] = T >>> 8 & 255, t[2] = T >>> 16 & 255, t[3] = T >>> 24 & 255, t[4] = B >>> 0 & 255, t[5] = B >>> 8 & 255, t[6] = B >>> 16 & 255, t[7] = B >>> 24 & 255, t[8] = E >>> 0 & 255, t[9] = E >>> 8 & 255, t[10] = E >>> 16 & 255, t[11] = E >>> 24 & 255, t[12] = C >>> 0 & 255, t[13] = C >>> 8 & 255, t[14] = C >>> 16 & 255, t[15] = C >>> 24 & 255, t[16] = $ >>> 0 & 255, t[17] = $ >>> 8 & 255, t[18] = $ >>> 16 & 255, t[19] = $ >>> 24 & 255, t[20] = S >>> 0 & 255, t[21] = S >>> 8 & 255, t[22] = S >>> 16 & 255, t[23] = S >>> 24 & 255, t[24] = u >>> 0 & 255, t[25] = u >>> 8 & 255, t[26] = u >>> 16 & 255, t[27] = u >>> 24 & 255, t[28] = d >>> 0 & 255, t[29] = d >>> 8 & 255, t[30] = d >>> 16 & 255, t[31] = d >>> 24 & 255, t[32] = w >>> 0 & 255, t[33] = w >>> 8 & 255, t[34] = w >>> 16 & 255, t[35] = w >>> 24 & 255, t[36] = l >>> 0 & 255, t[37] = l >>> 8 & 255, t[38] = l >>> 16 & 255, t[39] = l >>> 24 & 255, t[40] = y >>> 0 & 255, t[41] = y >>> 8 & 255, t[42] = y >>> 16 & 255, t[43] = y >>> 24 & 255, t[44] = g >>> 0 & 255, t[45] = g >>> 8 & 255, t[46] = g >>> 16 & 255, t[47] = g >>> 24 & 255, t[48] = I >>> 0 & 255, t[49] = I >>> 8 & 255, t[50] = I >>> 16 & 255, t[51] = I >>> 24 & 255, t[52] = N >>> 0 & 255, t[53] = N >>> 8 & 255, t[54] = N >>> 16 & 255, t[55] = N >>> 24 & 255, t[56] = z >>> 0 & 255, t[57] = z >>> 8 & 255, t[58] = z >>> 16 & 255, t[59] = z >>> 24 & 255, t[60] = K >>> 0 & 255, t[61] = K >>> 8 & 255, t[62] = K >>> 16 & 255, t[63] = K >>> 24 & 255;
    }
    function wt(t, n, r, e) {
      for (var f = e[0] & 255 | (e[1] & 255) << 8 | (e[2] & 255) << 16 | (e[3] & 255) << 24, i = r[0] & 255 | (r[1] & 255) << 8 | (r[2] & 255) << 16 | (r[3] & 255) << 24, c = r[4] & 255 | (r[5] & 255) << 8 | (r[6] & 255) << 16 | (r[7] & 255) << 24, p = r[8] & 255 | (r[9] & 255) << 8 | (r[10] & 255) << 16 | (r[11] & 255) << 24, A = r[12] & 255 | (r[13] & 255) << 8 | (r[14] & 255) << 16 | (r[15] & 255) << 24, q = e[4] & 255 | (e[5] & 255) << 8 | (e[6] & 255) << 16 | (e[7] & 255) << 24, _ = n[0] & 255 | (n[1] & 255) << 8 | (n[2] & 255) << 16 | (n[3] & 255) << 24, Q = n[4] & 255 | (n[5] & 255) << 8 | (n[6] & 255) << 16 | (n[7] & 255) << 24, R = n[8] & 255 | (n[9] & 255) << 8 | (n[10] & 255) << 16 | (n[11] & 255) << 24, P = n[12] & 255 | (n[13] & 255) << 8 | (n[14] & 255) << 16 | (n[15] & 255) << 24, M = e[8] & 255 | (e[9] & 255) << 8 | (e[10] & 255) << 16 | (e[11] & 255) << 24, F = r[16] & 255 | (r[17] & 255) << 8 | (r[18] & 255) << 16 | (r[19] & 255) << 24, k = r[20] & 255 | (r[21] & 255) << 8 | (r[22] & 255) << 16 | (r[23] & 255) << 24, L = r[24] & 255 | (r[25] & 255) << 8 | (r[26] & 255) << 16 | (r[27] & 255) << 24, G = r[28] & 255 | (r[29] & 255) << 8 | (r[30] & 255) << 16 | (r[31] & 255) << 24, j = e[12] & 255 | (e[13] & 255) << 8 | (e[14] & 255) << 16 | (e[15] & 255) << 24, T = f, B = i, E = c, C = p, $ = A, S = q, u = _, d = Q, w = R, l = P, y = M, g = F, I = k, N = L, z = G, K = j, o, V = 0; V < 20; V += 2)
        o = T + I | 0, $ ^= o << 7 | o >>> 25, o = $ + T | 0, w ^= o << 9 | o >>> 23, o = w + $ | 0, I ^= o << 13 | o >>> 19, o = I + w | 0, T ^= o << 18 | o >>> 14, o = S + B | 0, l ^= o << 7 | o >>> 25, o = l + S | 0, N ^= o << 9 | o >>> 23, o = N + l | 0, B ^= o << 13 | o >>> 19, o = B + N | 0, S ^= o << 18 | o >>> 14, o = y + u | 0, z ^= o << 7 | o >>> 25, o = z + y | 0, E ^= o << 9 | o >>> 23, o = E + z | 0, u ^= o << 13 | o >>> 19, o = u + E | 0, y ^= o << 18 | o >>> 14, o = K + g | 0, C ^= o << 7 | o >>> 25, o = C + K | 0, d ^= o << 9 | o >>> 23, o = d + C | 0, g ^= o << 13 | o >>> 19, o = g + d | 0, K ^= o << 18 | o >>> 14, o = T + C | 0, B ^= o << 7 | o >>> 25, o = B + T | 0, E ^= o << 9 | o >>> 23, o = E + B | 0, C ^= o << 13 | o >>> 19, o = C + E | 0, T ^= o << 18 | o >>> 14, o = S + $ | 0, u ^= o << 7 | o >>> 25, o = u + S | 0, d ^= o << 9 | o >>> 23, o = d + u | 0, $ ^= o << 13 | o >>> 19, o = $ + d | 0, S ^= o << 18 | o >>> 14, o = y + l | 0, g ^= o << 7 | o >>> 25, o = g + y | 0, w ^= o << 9 | o >>> 23, o = w + g | 0, l ^= o << 13 | o >>> 19, o = l + w | 0, y ^= o << 18 | o >>> 14, o = K + z | 0, I ^= o << 7 | o >>> 25, o = I + K | 0, N ^= o << 9 | o >>> 23, o = N + I | 0, z ^= o << 13 | o >>> 19, o = z + N | 0, K ^= o << 18 | o >>> 14;
      t[0] = T >>> 0 & 255, t[1] = T >>> 8 & 255, t[2] = T >>> 16 & 255, t[3] = T >>> 24 & 255, t[4] = S >>> 0 & 255, t[5] = S >>> 8 & 255, t[6] = S >>> 16 & 255, t[7] = S >>> 24 & 255, t[8] = y >>> 0 & 255, t[9] = y >>> 8 & 255, t[10] = y >>> 16 & 255, t[11] = y >>> 24 & 255, t[12] = K >>> 0 & 255, t[13] = K >>> 8 & 255, t[14] = K >>> 16 & 255, t[15] = K >>> 24 & 255, t[16] = u >>> 0 & 255, t[17] = u >>> 8 & 255, t[18] = u >>> 16 & 255, t[19] = u >>> 24 & 255, t[20] = d >>> 0 & 255, t[21] = d >>> 8 & 255, t[22] = d >>> 16 & 255, t[23] = d >>> 24 & 255, t[24] = w >>> 0 & 255, t[25] = w >>> 8 & 255, t[26] = w >>> 16 & 255, t[27] = w >>> 24 & 255, t[28] = l >>> 0 & 255, t[29] = l >>> 8 & 255, t[30] = l >>> 16 & 255, t[31] = l >>> 24 & 255;
    }
    function je(t, n, r, e) {
      bt(t, n, r, e);
    }
    function qe(t, n, r, e) {
      wt(t, n, r, e);
    }
    var Te = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
    function et(t, n, r, e, f, i, c) {
      var p = new Uint8Array(16), A = new Uint8Array(64), q, _;
      for (_ = 0; _ < 16; _++)
        p[_] = 0;
      for (_ = 0; _ < 8; _++)
        p[_] = i[_];
      for (; f >= 64; ) {
        for (je(A, p, c, Te), _ = 0; _ < 64; _++)
          t[n + _] = r[e + _] ^ A[_];
        for (q = 1, _ = 8; _ < 16; _++)
          q = q + (p[_] & 255) | 0, p[_] = q & 255, q >>>= 8;
        f -= 64, n += 64, e += 64;
      }
      if (f > 0)
        for (je(A, p, c, Te), _ = 0; _ < f; _++)
          t[n + _] = r[e + _] ^ A[_];
      return 0;
    }
    function tt(t, n, r, e, f) {
      var i = new Uint8Array(16), c = new Uint8Array(64), p, A;
      for (A = 0; A < 16; A++)
        i[A] = 0;
      for (A = 0; A < 8; A++)
        i[A] = e[A];
      for (; r >= 64; ) {
        for (je(c, i, f, Te), A = 0; A < 64; A++)
          t[n + A] = c[A];
        for (p = 1, A = 8; A < 16; A++)
          p = p + (i[A] & 255) | 0, i[A] = p & 255, p >>>= 8;
        r -= 64, n += 64;
      }
      if (r > 0)
        for (je(c, i, f, Te), A = 0; A < r; A++)
          t[n + A] = c[A];
      return 0;
    }
    function De(t, n, r, e, f) {
      var i = new Uint8Array(32);
      qe(i, e, f, Te);
      for (var c = new Uint8Array(8), p = 0; p < 8; p++)
        c[p] = e[p + 16];
      return tt(t, n, r, c, i);
    }
    function Ke(t, n, r, e, f, i, c) {
      var p = new Uint8Array(32);
      qe(p, i, c, Te);
      for (var A = new Uint8Array(8), q = 0; q < 8; q++)
        A[q] = i[q + 16];
      return et(t, n, r, e, f, A, p);
    }
    var Ge = function(t) {
      this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0;
      var n, r, e, f, i, c, p, A;
      n = t[0] & 255 | (t[1] & 255) << 8, this.r[0] = n & 8191, r = t[2] & 255 | (t[3] & 255) << 8, this.r[1] = (n >>> 13 | r << 3) & 8191, e = t[4] & 255 | (t[5] & 255) << 8, this.r[2] = (r >>> 10 | e << 6) & 7939, f = t[6] & 255 | (t[7] & 255) << 8, this.r[3] = (e >>> 7 | f << 9) & 8191, i = t[8] & 255 | (t[9] & 255) << 8, this.r[4] = (f >>> 4 | i << 12) & 255, this.r[5] = i >>> 1 & 8190, c = t[10] & 255 | (t[11] & 255) << 8, this.r[6] = (i >>> 14 | c << 2) & 8191, p = t[12] & 255 | (t[13] & 255) << 8, this.r[7] = (c >>> 11 | p << 5) & 8065, A = t[14] & 255 | (t[15] & 255) << 8, this.r[8] = (p >>> 8 | A << 8) & 8191, this.r[9] = A >>> 5 & 127, this.pad[0] = t[16] & 255 | (t[17] & 255) << 8, this.pad[1] = t[18] & 255 | (t[19] & 255) << 8, this.pad[2] = t[20] & 255 | (t[21] & 255) << 8, this.pad[3] = t[22] & 255 | (t[23] & 255) << 8, this.pad[4] = t[24] & 255 | (t[25] & 255) << 8, this.pad[5] = t[26] & 255 | (t[27] & 255) << 8, this.pad[6] = t[28] & 255 | (t[29] & 255) << 8, this.pad[7] = t[30] & 255 | (t[31] & 255) << 8;
    };
    Ge.prototype.blocks = function(t, n, r) {
      for (var e = this.fin ? 0 : 2048, f, i, c, p, A, q, _, Q, R, P, M, F, k, L, G, j, T, B, E, C = this.h[0], $ = this.h[1], S = this.h[2], u = this.h[3], d = this.h[4], w = this.h[5], l = this.h[6], y = this.h[7], g = this.h[8], I = this.h[9], N = this.r[0], z = this.r[1], K = this.r[2], o = this.r[3], V = this.r[4], ee = this.r[5], te = this.r[6], Y = this.r[7], X = this.r[8], W = this.r[9]; r >= 16; )
        f = t[n + 0] & 255 | (t[n + 1] & 255) << 8, C += f & 8191, i = t[n + 2] & 255 | (t[n + 3] & 255) << 8, $ += (f >>> 13 | i << 3) & 8191, c = t[n + 4] & 255 | (t[n + 5] & 255) << 8, S += (i >>> 10 | c << 6) & 8191, p = t[n + 6] & 255 | (t[n + 7] & 255) << 8, u += (c >>> 7 | p << 9) & 8191, A = t[n + 8] & 255 | (t[n + 9] & 255) << 8, d += (p >>> 4 | A << 12) & 8191, w += A >>> 1 & 8191, q = t[n + 10] & 255 | (t[n + 11] & 255) << 8, l += (A >>> 14 | q << 2) & 8191, _ = t[n + 12] & 255 | (t[n + 13] & 255) << 8, y += (q >>> 11 | _ << 5) & 8191, Q = t[n + 14] & 255 | (t[n + 15] & 255) << 8, g += (_ >>> 8 | Q << 8) & 8191, I += Q >>> 5 | e, R = 0, P = R, P += C * N, P += $ * (5 * W), P += S * (5 * X), P += u * (5 * Y), P += d * (5 * te), R = P >>> 13, P &= 8191, P += w * (5 * ee), P += l * (5 * V), P += y * (5 * o), P += g * (5 * K), P += I * (5 * z), R += P >>> 13, P &= 8191, M = R, M += C * z, M += $ * N, M += S * (5 * W), M += u * (5 * X), M += d * (5 * Y), R = M >>> 13, M &= 8191, M += w * (5 * te), M += l * (5 * ee), M += y * (5 * V), M += g * (5 * o), M += I * (5 * K), R += M >>> 13, M &= 8191, F = R, F += C * K, F += $ * z, F += S * N, F += u * (5 * W), F += d * (5 * X), R = F >>> 13, F &= 8191, F += w * (5 * Y), F += l * (5 * te), F += y * (5 * ee), F += g * (5 * V), F += I * (5 * o), R += F >>> 13, F &= 8191, k = R, k += C * o, k += $ * K, k += S * z, k += u * N, k += d * (5 * W), R = k >>> 13, k &= 8191, k += w * (5 * X), k += l * (5 * Y), k += y * (5 * te), k += g * (5 * ee), k += I * (5 * V), R += k >>> 13, k &= 8191, L = R, L += C * V, L += $ * o, L += S * K, L += u * z, L += d * N, R = L >>> 13, L &= 8191, L += w * (5 * W), L += l * (5 * X), L += y * (5 * Y), L += g * (5 * te), L += I * (5 * ee), R += L >>> 13, L &= 8191, G = R, G += C * ee, G += $ * V, G += S * o, G += u * K, G += d * z, R = G >>> 13, G &= 8191, G += w * N, G += l * (5 * W), G += y * (5 * X), G += g * (5 * Y), G += I * (5 * te), R += G >>> 13, G &= 8191, j = R, j += C * te, j += $ * ee, j += S * V, j += u * o, j += d * K, R = j >>> 13, j &= 8191, j += w * z, j += l * N, j += y * (5 * W), j += g * (5 * X), j += I * (5 * Y), R += j >>> 13, j &= 8191, T = R, T += C * Y, T += $ * te, T += S * ee, T += u * V, T += d * o, R = T >>> 13, T &= 8191, T += w * K, T += l * z, T += y * N, T += g * (5 * W), T += I * (5 * X), R += T >>> 13, T &= 8191, B = R, B += C * X, B += $ * Y, B += S * te, B += u * ee, B += d * V, R = B >>> 13, B &= 8191, B += w * o, B += l * K, B += y * z, B += g * N, B += I * (5 * W), R += B >>> 13, B &= 8191, E = R, E += C * W, E += $ * X, E += S * Y, E += u * te, E += d * ee, R = E >>> 13, E &= 8191, E += w * V, E += l * o, E += y * K, E += g * z, E += I * N, R += E >>> 13, E &= 8191, R = (R << 2) + R | 0, R = R + P | 0, P = R & 8191, R = R >>> 13, M += R, C = P, $ = M, S = F, u = k, d = L, w = G, l = j, y = T, g = B, I = E, n += 16, r -= 16;
      this.h[0] = C, this.h[1] = $, this.h[2] = S, this.h[3] = u, this.h[4] = d, this.h[5] = w, this.h[6] = l, this.h[7] = y, this.h[8] = g, this.h[9] = I;
    }, Ge.prototype.finish = function(t, n) {
      var r = new Uint16Array(10), e, f, i, c;
      if (this.leftover) {
        for (c = this.leftover, this.buffer[c++] = 1; c < 16; c++)
          this.buffer[c] = 0;
        this.fin = 1, this.blocks(this.buffer, 0, 16);
      }
      for (e = this.h[1] >>> 13, this.h[1] &= 8191, c = 2; c < 10; c++)
        this.h[c] += e, e = this.h[c] >>> 13, this.h[c] &= 8191;
      for (this.h[0] += e * 5, e = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += e, e = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += e, r[0] = this.h[0] + 5, e = r[0] >>> 13, r[0] &= 8191, c = 1; c < 10; c++)
        r[c] = this.h[c] + e, e = r[c] >>> 13, r[c] &= 8191;
      for (r[9] -= 8192, f = (e ^ 1) - 1, c = 0; c < 10; c++)
        r[c] &= f;
      for (f = ~f, c = 0; c < 10; c++)
        this.h[c] = this.h[c] & f | r[c];
      for (this.h[0] = (this.h[0] | this.h[1] << 13) & 65535, this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535, this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535, this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535, this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535, this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535, this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535, this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535, i = this.h[0] + this.pad[0], this.h[0] = i & 65535, c = 1; c < 8; c++)
        i = (this.h[c] + this.pad[c] | 0) + (i >>> 16) | 0, this.h[c] = i & 65535;
      t[n + 0] = this.h[0] >>> 0 & 255, t[n + 1] = this.h[0] >>> 8 & 255, t[n + 2] = this.h[1] >>> 0 & 255, t[n + 3] = this.h[1] >>> 8 & 255, t[n + 4] = this.h[2] >>> 0 & 255, t[n + 5] = this.h[2] >>> 8 & 255, t[n + 6] = this.h[3] >>> 0 & 255, t[n + 7] = this.h[3] >>> 8 & 255, t[n + 8] = this.h[4] >>> 0 & 255, t[n + 9] = this.h[4] >>> 8 & 255, t[n + 10] = this.h[5] >>> 0 & 255, t[n + 11] = this.h[5] >>> 8 & 255, t[n + 12] = this.h[6] >>> 0 & 255, t[n + 13] = this.h[6] >>> 8 & 255, t[n + 14] = this.h[7] >>> 0 & 255, t[n + 15] = this.h[7] >>> 8 & 255;
    }, Ge.prototype.update = function(t, n, r) {
      var e, f;
      if (this.leftover) {
        for (f = 16 - this.leftover, f > r && (f = r), e = 0; e < f; e++)
          this.buffer[this.leftover + e] = t[n + e];
        if (r -= f, n += f, this.leftover += f, this.leftover < 16)
          return;
        this.blocks(this.buffer, 0, 16), this.leftover = 0;
      }
      if (r >= 16 && (f = r - r % 16, this.blocks(t, n, f), n += f, r -= f), r) {
        for (e = 0; e < r; e++)
          this.buffer[this.leftover + e] = t[n + e];
        this.leftover += r;
      }
    };
    function Se(t, n, r, e, f, i) {
      var c = new Ge(i);
      return c.update(r, e, f), c.finish(t, n), 0;
    }
    function rt(t, n, r, e, f, i) {
      var c = new Uint8Array(16);
      return Se(c, 0, r, e, f, i), Oe(t, n, c, 0);
    }
    function Be(t, n, r, e, f) {
      var i;
      if (r < 32)
        return -1;
      for (Ke(t, 0, n, 0, r, e, f), Se(t, 16, t, 32, r - 32, t), i = 0; i < 16; i++)
        t[i] = 0;
      return 0;
    }
    function h(t, n, r, e, f) {
      var i, c = new Uint8Array(32);
      if (r < 32 || (De(c, 0, 32, e, f), rt(n, 16, n, 32, r - 32, c) !== 0))
        return -1;
      for (Ke(t, 0, n, 0, r, e, f), i = 0; i < 32; i++)
        t[i] = 0;
      return 0;
    }
    function m(t, n) {
      var r;
      for (r = 0; r < 16; r++)
        t[r] = n[r] | 0;
    }
    function J(t) {
      var n, r, e = 1;
      for (n = 0; n < 16; n++)
        r = t[n] + e + 65535, e = Math.floor(r / 65536), t[n] = r - e * 65536;
      t[0] += e - 1 + 37 * (e - 1);
    }
    function ne(t, n, r) {
      for (var e, f = ~(r - 1), i = 0; i < 16; i++)
        e = f & (t[i] ^ n[i]), t[i] ^= e, n[i] ^= e;
    }
    function ae(t, n) {
      var r, e, f, i = s(), c = s();
      for (r = 0; r < 16; r++)
        c[r] = n[r];
      for (J(c), J(c), J(c), e = 0; e < 2; e++) {
        for (i[0] = c[0] - 65517, r = 1; r < 15; r++)
          i[r] = c[r] - 65535 - (i[r - 1] >> 16 & 1), i[r - 1] &= 65535;
        i[15] = c[15] - 32767 - (i[14] >> 16 & 1), f = i[15] >> 16 & 1, i[14] &= 65535, ne(c, i, 1 - f);
      }
      for (r = 0; r < 16; r++)
        t[2 * r] = c[r] & 255, t[2 * r + 1] = c[r] >> 8;
    }
    function re(t, n) {
      var r = new Uint8Array(32), e = new Uint8Array(32);
      return ae(r, t), ae(e, n), Le(r, 0, e, 0);
    }
    function Ie(t) {
      var n = new Uint8Array(32);
      return ae(n, t), n[0] & 1;
    }
    function ze(t, n) {
      var r;
      for (r = 0; r < 16; r++)
        t[r] = n[2 * r] + (n[2 * r + 1] << 8);
      t[15] &= 32767;
    }
    function ie(t, n, r) {
      for (var e = 0; e < 16; e++)
        t[e] = n[e] + r[e];
    }
    function ve(t, n, r) {
      for (var e = 0; e < 16; e++)
        t[e] = n[e] - r[e];
    }
    function Z(t, n, r) {
      var e, f, i = 0, c = 0, p = 0, A = 0, q = 0, _ = 0, Q = 0, R = 0, P = 0, M = 0, F = 0, k = 0, L = 0, G = 0, j = 0, T = 0, B = 0, E = 0, C = 0, $ = 0, S = 0, u = 0, d = 0, w = 0, l = 0, y = 0, g = 0, I = 0, N = 0, z = 0, K = 0, o = r[0], V = r[1], ee = r[2], te = r[3], Y = r[4], X = r[5], W = r[6], xe = r[7], fe = r[8], ue = r[9], de = r[10], he = r[11], pe = r[12], ge = r[13], me = r[14], Ae = r[15];
      e = n[0], i += e * o, c += e * V, p += e * ee, A += e * te, q += e * Y, _ += e * X, Q += e * W, R += e * xe, P += e * fe, M += e * ue, F += e * de, k += e * he, L += e * pe, G += e * ge, j += e * me, T += e * Ae, e = n[1], c += e * o, p += e * V, A += e * ee, q += e * te, _ += e * Y, Q += e * X, R += e * W, P += e * xe, M += e * fe, F += e * ue, k += e * de, L += e * he, G += e * pe, j += e * ge, T += e * me, B += e * Ae, e = n[2], p += e * o, A += e * V, q += e * ee, _ += e * te, Q += e * Y, R += e * X, P += e * W, M += e * xe, F += e * fe, k += e * ue, L += e * de, G += e * he, j += e * pe, T += e * ge, B += e * me, E += e * Ae, e = n[3], A += e * o, q += e * V, _ += e * ee, Q += e * te, R += e * Y, P += e * X, M += e * W, F += e * xe, k += e * fe, L += e * ue, G += e * de, j += e * he, T += e * pe, B += e * ge, E += e * me, C += e * Ae, e = n[4], q += e * o, _ += e * V, Q += e * ee, R += e * te, P += e * Y, M += e * X, F += e * W, k += e * xe, L += e * fe, G += e * ue, j += e * de, T += e * he, B += e * pe, E += e * ge, C += e * me, $ += e * Ae, e = n[5], _ += e * o, Q += e * V, R += e * ee, P += e * te, M += e * Y, F += e * X, k += e * W, L += e * xe, G += e * fe, j += e * ue, T += e * de, B += e * he, E += e * pe, C += e * ge, $ += e * me, S += e * Ae, e = n[6], Q += e * o, R += e * V, P += e * ee, M += e * te, F += e * Y, k += e * X, L += e * W, G += e * xe, j += e * fe, T += e * ue, B += e * de, E += e * he, C += e * pe, $ += e * ge, S += e * me, u += e * Ae, e = n[7], R += e * o, P += e * V, M += e * ee, F += e * te, k += e * Y, L += e * X, G += e * W, j += e * xe, T += e * fe, B += e * ue, E += e * de, C += e * he, $ += e * pe, S += e * ge, u += e * me, d += e * Ae, e = n[8], P += e * o, M += e * V, F += e * ee, k += e * te, L += e * Y, G += e * X, j += e * W, T += e * xe, B += e * fe, E += e * ue, C += e * de, $ += e * he, S += e * pe, u += e * ge, d += e * me, w += e * Ae, e = n[9], M += e * o, F += e * V, k += e * ee, L += e * te, G += e * Y, j += e * X, T += e * W, B += e * xe, E += e * fe, C += e * ue, $ += e * de, S += e * he, u += e * pe, d += e * ge, w += e * me, l += e * Ae, e = n[10], F += e * o, k += e * V, L += e * ee, G += e * te, j += e * Y, T += e * X, B += e * W, E += e * xe, C += e * fe, $ += e * ue, S += e * de, u += e * he, d += e * pe, w += e * ge, l += e * me, y += e * Ae, e = n[11], k += e * o, L += e * V, G += e * ee, j += e * te, T += e * Y, B += e * X, E += e * W, C += e * xe, $ += e * fe, S += e * ue, u += e * de, d += e * he, w += e * pe, l += e * ge, y += e * me, g += e * Ae, e = n[12], L += e * o, G += e * V, j += e * ee, T += e * te, B += e * Y, E += e * X, C += e * W, $ += e * xe, S += e * fe, u += e * ue, d += e * de, w += e * he, l += e * pe, y += e * ge, g += e * me, I += e * Ae, e = n[13], G += e * o, j += e * V, T += e * ee, B += e * te, E += e * Y, C += e * X, $ += e * W, S += e * xe, u += e * fe, d += e * ue, w += e * de, l += e * he, y += e * pe, g += e * ge, I += e * me, N += e * Ae, e = n[14], j += e * o, T += e * V, B += e * ee, E += e * te, C += e * Y, $ += e * X, S += e * W, u += e * xe, d += e * fe, w += e * ue, l += e * de, y += e * he, g += e * pe, I += e * ge, N += e * me, z += e * Ae, e = n[15], T += e * o, B += e * V, E += e * ee, C += e * te, $ += e * Y, S += e * X, u += e * W, d += e * xe, w += e * fe, l += e * ue, y += e * de, g += e * he, I += e * pe, N += e * ge, z += e * me, K += e * Ae, i += 38 * B, c += 38 * E, p += 38 * C, A += 38 * $, q += 38 * S, _ += 38 * u, Q += 38 * d, R += 38 * w, P += 38 * l, M += 38 * y, F += 38 * g, k += 38 * I, L += 38 * N, G += 38 * z, j += 38 * K, f = 1, e = i + f + 65535, f = Math.floor(e / 65536), i = e - f * 65536, e = c + f + 65535, f = Math.floor(e / 65536), c = e - f * 65536, e = p + f + 65535, f = Math.floor(e / 65536), p = e - f * 65536, e = A + f + 65535, f = Math.floor(e / 65536), A = e - f * 65536, e = q + f + 65535, f = Math.floor(e / 65536), q = e - f * 65536, e = _ + f + 65535, f = Math.floor(e / 65536), _ = e - f * 65536, e = Q + f + 65535, f = Math.floor(e / 65536), Q = e - f * 65536, e = R + f + 65535, f = Math.floor(e / 65536), R = e - f * 65536, e = P + f + 65535, f = Math.floor(e / 65536), P = e - f * 65536, e = M + f + 65535, f = Math.floor(e / 65536), M = e - f * 65536, e = F + f + 65535, f = Math.floor(e / 65536), F = e - f * 65536, e = k + f + 65535, f = Math.floor(e / 65536), k = e - f * 65536, e = L + f + 65535, f = Math.floor(e / 65536), L = e - f * 65536, e = G + f + 65535, f = Math.floor(e / 65536), G = e - f * 65536, e = j + f + 65535, f = Math.floor(e / 65536), j = e - f * 65536, e = T + f + 65535, f = Math.floor(e / 65536), T = e - f * 65536, i += f - 1 + 37 * (f - 1), f = 1, e = i + f + 65535, f = Math.floor(e / 65536), i = e - f * 65536, e = c + f + 65535, f = Math.floor(e / 65536), c = e - f * 65536, e = p + f + 65535, f = Math.floor(e / 65536), p = e - f * 65536, e = A + f + 65535, f = Math.floor(e / 65536), A = e - f * 65536, e = q + f + 65535, f = Math.floor(e / 65536), q = e - f * 65536, e = _ + f + 65535, f = Math.floor(e / 65536), _ = e - f * 65536, e = Q + f + 65535, f = Math.floor(e / 65536), Q = e - f * 65536, e = R + f + 65535, f = Math.floor(e / 65536), R = e - f * 65536, e = P + f + 65535, f = Math.floor(e / 65536), P = e - f * 65536, e = M + f + 65535, f = Math.floor(e / 65536), M = e - f * 65536, e = F + f + 65535, f = Math.floor(e / 65536), F = e - f * 65536, e = k + f + 65535, f = Math.floor(e / 65536), k = e - f * 65536, e = L + f + 65535, f = Math.floor(e / 65536), L = e - f * 65536, e = G + f + 65535, f = Math.floor(e / 65536), G = e - f * 65536, e = j + f + 65535, f = Math.floor(e / 65536), j = e - f * 65536, e = T + f + 65535, f = Math.floor(e / 65536), T = e - f * 65536, i += f - 1 + 37 * (f - 1), t[0] = i, t[1] = c, t[2] = p, t[3] = A, t[4] = q, t[5] = _, t[6] = Q, t[7] = R, t[8] = P, t[9] = M, t[10] = F, t[11] = k, t[12] = L, t[13] = G, t[14] = j, t[15] = T;
    }
    function Re(t, n) {
      Z(t, n, n);
    }
    function Pt(t, n) {
      var r = s(), e;
      for (e = 0; e < 16; e++)
        r[e] = n[e];
      for (e = 253; e >= 0; e--)
        Re(r, r), e !== 2 && e !== 4 && Z(r, r, n);
      for (e = 0; e < 16; e++)
        t[e] = r[e];
    }
    function Mt(t, n) {
      var r = s(), e;
      for (e = 0; e < 16; e++)
        r[e] = n[e];
      for (e = 250; e >= 0; e--)
        Re(r, r), e !== 1 && Z(r, r, n);
      for (e = 0; e < 16; e++)
        t[e] = r[e];
    }
    function nt(t, n, r) {
      var e = new Uint8Array(32), f = new Float64Array(80), i, c, p = s(), A = s(), q = s(), _ = s(), Q = s(), R = s();
      for (c = 0; c < 31; c++)
        e[c] = n[c];
      for (e[31] = n[31] & 127 | 64, e[0] &= 248, ze(f, r), c = 0; c < 16; c++)
        A[c] = f[c], _[c] = p[c] = q[c] = 0;
      for (p[0] = _[0] = 1, c = 254; c >= 0; --c)
        i = e[c >>> 3] >>> (c & 7) & 1, ne(p, A, i), ne(q, _, i), ie(Q, p, q), ve(p, p, q), ie(q, A, _), ve(A, A, _), Re(_, Q), Re(R, p), Z(p, q, p), Z(q, A, Q), ie(Q, p, q), ve(p, p, q), Re(A, p), ve(q, _, R), Z(p, q, H), ie(p, p, _), Z(q, q, p), Z(p, _, R), Z(_, A, f), Re(A, Q), ne(p, A, i), ne(q, _, i);
      for (c = 0; c < 16; c++)
        f[c + 16] = p[c], f[c + 32] = q[c], f[c + 48] = A[c], f[c + 64] = _[c];
      var P = f.subarray(32), M = f.subarray(16);
      return Pt(P, P), Z(M, M, P), ae(t, M), 0;
    }
    function ft(t, n) {
      return nt(t, n, U);
    }
    function Lt(t, n) {
      return b(n, 32), ft(t, n);
    }
    function ot(t, n, r) {
      var e = new Uint8Array(32);
      return nt(e, r, n), qe(t, v, e, Te);
    }
    var jt = Be, ar = h;
    function sr(t, n, r, e, f, i) {
      var c = new Uint8Array(32);
      return ot(c, f, i), jt(t, n, r, e, c);
    }
    function ir(t, n, r, e, f, i) {
      var c = new Uint8Array(32);
      return ot(c, f, i), ar(t, n, r, e, c);
    }
    var Gt = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ];
    function Ht(t, n, r, e) {
      for (var f = new Int32Array(16), i = new Int32Array(16), c, p, A, q, _, Q, R, P, M, F, k, L, G, j, T, B, E, C, $, S, u, d, w, l, y, g, I = t[0], N = t[1], z = t[2], K = t[3], o = t[4], V = t[5], ee = t[6], te = t[7], Y = n[0], X = n[1], W = n[2], xe = n[3], fe = n[4], ue = n[5], de = n[6], he = n[7], pe = 0; e >= 128; ) {
        for ($ = 0; $ < 16; $++)
          S = 8 * $ + pe, f[$] = r[S + 0] << 24 | r[S + 1] << 16 | r[S + 2] << 8 | r[S + 3], i[$] = r[S + 4] << 24 | r[S + 5] << 16 | r[S + 6] << 8 | r[S + 7];
        for ($ = 0; $ < 80; $++)
          if (c = I, p = N, A = z, q = K, _ = o, Q = V, R = ee, P = te, M = Y, F = X, k = W, L = xe, G = fe, j = ue, T = de, B = he, u = te, d = he, w = d & 65535, l = d >>> 16, y = u & 65535, g = u >>> 16, u = (o >>> 14 | fe << 18) ^ (o >>> 18 | fe << 14) ^ (fe >>> 9 | o << 23), d = (fe >>> 14 | o << 18) ^ (fe >>> 18 | o << 14) ^ (o >>> 9 | fe << 23), w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, u = o & V ^ ~o & ee, d = fe & ue ^ ~fe & de, w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, u = Gt[$ * 2], d = Gt[$ * 2 + 1], w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, u = f[$ % 16], d = i[$ % 16], w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, l += w >>> 16, y += l >>> 16, g += y >>> 16, E = y & 65535 | g << 16, C = w & 65535 | l << 16, u = E, d = C, w = d & 65535, l = d >>> 16, y = u & 65535, g = u >>> 16, u = (I >>> 28 | Y << 4) ^ (Y >>> 2 | I << 30) ^ (Y >>> 7 | I << 25), d = (Y >>> 28 | I << 4) ^ (I >>> 2 | Y << 30) ^ (I >>> 7 | Y << 25), w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, u = I & N ^ I & z ^ N & z, d = Y & X ^ Y & W ^ X & W, w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, l += w >>> 16, y += l >>> 16, g += y >>> 16, P = y & 65535 | g << 16, B = w & 65535 | l << 16, u = q, d = L, w = d & 65535, l = d >>> 16, y = u & 65535, g = u >>> 16, u = E, d = C, w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, l += w >>> 16, y += l >>> 16, g += y >>> 16, q = y & 65535 | g << 16, L = w & 65535 | l << 16, N = c, z = p, K = A, o = q, V = _, ee = Q, te = R, I = P, X = M, W = F, xe = k, fe = L, ue = G, de = j, he = T, Y = B, $ % 16 === 15)
            for (S = 0; S < 16; S++)
              u = f[S], d = i[S], w = d & 65535, l = d >>> 16, y = u & 65535, g = u >>> 16, u = f[(S + 9) % 16], d = i[(S + 9) % 16], w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, E = f[(S + 1) % 16], C = i[(S + 1) % 16], u = (E >>> 1 | C << 31) ^ (E >>> 8 | C << 24) ^ E >>> 7, d = (C >>> 1 | E << 31) ^ (C >>> 8 | E << 24) ^ (C >>> 7 | E << 25), w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, E = f[(S + 14) % 16], C = i[(S + 14) % 16], u = (E >>> 19 | C << 13) ^ (C >>> 29 | E << 3) ^ E >>> 6, d = (C >>> 19 | E << 13) ^ (E >>> 29 | C << 3) ^ (C >>> 6 | E << 26), w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, l += w >>> 16, y += l >>> 16, g += y >>> 16, f[S] = y & 65535 | g << 16, i[S] = w & 65535 | l << 16;
        u = I, d = Y, w = d & 65535, l = d >>> 16, y = u & 65535, g = u >>> 16, u = t[0], d = n[0], w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, l += w >>> 16, y += l >>> 16, g += y >>> 16, t[0] = I = y & 65535 | g << 16, n[0] = Y = w & 65535 | l << 16, u = N, d = X, w = d & 65535, l = d >>> 16, y = u & 65535, g = u >>> 16, u = t[1], d = n[1], w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, l += w >>> 16, y += l >>> 16, g += y >>> 16, t[1] = N = y & 65535 | g << 16, n[1] = X = w & 65535 | l << 16, u = z, d = W, w = d & 65535, l = d >>> 16, y = u & 65535, g = u >>> 16, u = t[2], d = n[2], w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, l += w >>> 16, y += l >>> 16, g += y >>> 16, t[2] = z = y & 65535 | g << 16, n[2] = W = w & 65535 | l << 16, u = K, d = xe, w = d & 65535, l = d >>> 16, y = u & 65535, g = u >>> 16, u = t[3], d = n[3], w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, l += w >>> 16, y += l >>> 16, g += y >>> 16, t[3] = K = y & 65535 | g << 16, n[3] = xe = w & 65535 | l << 16, u = o, d = fe, w = d & 65535, l = d >>> 16, y = u & 65535, g = u >>> 16, u = t[4], d = n[4], w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, l += w >>> 16, y += l >>> 16, g += y >>> 16, t[4] = o = y & 65535 | g << 16, n[4] = fe = w & 65535 | l << 16, u = V, d = ue, w = d & 65535, l = d >>> 16, y = u & 65535, g = u >>> 16, u = t[5], d = n[5], w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, l += w >>> 16, y += l >>> 16, g += y >>> 16, t[5] = V = y & 65535 | g << 16, n[5] = ue = w & 65535 | l << 16, u = ee, d = de, w = d & 65535, l = d >>> 16, y = u & 65535, g = u >>> 16, u = t[6], d = n[6], w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, l += w >>> 16, y += l >>> 16, g += y >>> 16, t[6] = ee = y & 65535 | g << 16, n[6] = de = w & 65535 | l << 16, u = te, d = he, w = d & 65535, l = d >>> 16, y = u & 65535, g = u >>> 16, u = t[7], d = n[7], w += d & 65535, l += d >>> 16, y += u & 65535, g += u >>> 16, l += w >>> 16, y += l >>> 16, g += y >>> 16, t[7] = te = y & 65535 | g << 16, n[7] = he = w & 65535 | l << 16, pe += 128, e -= 128;
      }
      return e;
    }
    function Pe(t, n, r) {
      var e = new Int32Array(8), f = new Int32Array(8), i = new Uint8Array(256), c, p = r;
      for (e[0] = 1779033703, e[1] = 3144134277, e[2] = 1013904242, e[3] = 2773480762, e[4] = 1359893119, e[5] = 2600822924, e[6] = 528734635, e[7] = 1541459225, f[0] = 4089235720, f[1] = 2227873595, f[2] = 4271175723, f[3] = 1595750129, f[4] = 2917565137, f[5] = 725511199, f[6] = 4215389547, f[7] = 327033209, Ht(e, f, n, r), r %= 128, c = 0; c < r; c++)
        i[c] = n[p - r + c];
      for (i[r] = 128, r = 256 - 128 * (r < 112 ? 1 : 0), i[r - 9] = 0, Ue(i, r - 8, p / 536870912 | 0, p << 3), Ht(e, f, i, r), c = 0; c < 8; c++)
        Ue(t, 8 * c, e[c], f[c]);
      return 0;
    }
    function at(t, n) {
      var r = s(), e = s(), f = s(), i = s(), c = s(), p = s(), A = s(), q = s(), _ = s();
      ve(r, t[1], t[0]), ve(_, n[1], n[0]), Z(r, r, _), ie(e, t[0], t[1]), ie(_, n[0], n[1]), Z(e, e, _), Z(f, t[3], n[3]), Z(f, f, ye), Z(i, t[2], n[2]), ie(i, i, i), ve(c, e, r), ve(p, i, f), ie(A, i, f), ie(q, e, r), Z(t[0], c, p), Z(t[1], q, A), Z(t[2], A, p), Z(t[3], c, q);
    }
    function kt(t, n, r) {
      var e;
      for (e = 0; e < 4; e++)
        ne(t[e], n[e], r);
    }
    function vt(t, n) {
      var r = s(), e = s(), f = s();
      Pt(f, n[2]), Z(r, n[0], f), Z(e, n[1], f), ae(t, e), t[31] ^= Ie(r) << 7;
    }
    function gt(t, n, r) {
      var e, f;
      for (m(t[0], D), m(t[1], O), m(t[2], O), m(t[3], D), f = 255; f >= 0; --f)
        e = r[f / 8 | 0] >> (f & 7) & 1, kt(t, n, e), at(n, t), at(t, t), kt(t, n, e);
    }
    function st(t, n) {
      var r = [s(), s(), s(), s()];
      m(r[0], le), m(r[1], we), m(r[2], O), Z(r[3], le, we), gt(t, r, n);
    }
    function mt(t, n, r) {
      var e = new Uint8Array(64), f = [s(), s(), s(), s()], i;
      for (r || b(n, 32), Pe(e, n, 32), e[0] &= 248, e[31] &= 127, e[31] |= 64, st(f, e), vt(t, f), i = 0; i < 32; i++)
        n[i + 32] = t[i];
      return 0;
    }
    var it = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
    function At(t, n) {
      var r, e, f, i;
      for (e = 63; e >= 32; --e) {
        for (r = 0, f = e - 32, i = e - 12; f < i; ++f)
          n[f] += r - 16 * n[e] * it[f - (e - 32)], r = Math.floor((n[f] + 128) / 256), n[f] -= r * 256;
        n[f] += r, n[e] = 0;
      }
      for (r = 0, f = 0; f < 32; f++)
        n[f] += r - (n[31] >> 4) * it[f], r = n[f] >> 8, n[f] &= 255;
      for (f = 0; f < 32; f++)
        n[f] -= r * it[f];
      for (e = 0; e < 32; e++)
        n[e + 1] += n[e] >> 8, t[e] = n[e] & 255;
    }
    function St(t) {
      var n = new Float64Array(64), r;
      for (r = 0; r < 64; r++)
        n[r] = t[r];
      for (r = 0; r < 64; r++)
        t[r] = 0;
      At(t, n);
    }
    function Jt(t, n, r, e) {
      var f = new Uint8Array(64), i = new Uint8Array(64), c = new Uint8Array(64), p, A, q = new Float64Array(64), _ = [s(), s(), s(), s()];
      Pe(f, e, 32), f[0] &= 248, f[31] &= 127, f[31] |= 64;
      var Q = r + 64;
      for (p = 0; p < r; p++)
        t[64 + p] = n[p];
      for (p = 0; p < 32; p++)
        t[32 + p] = f[32 + p];
      for (Pe(c, t.subarray(32), r + 32), St(c), st(_, c), vt(t, _), p = 32; p < 64; p++)
        t[p] = e[p];
      for (Pe(i, t, r + 64), St(i), p = 0; p < 64; p++)
        q[p] = 0;
      for (p = 0; p < 32; p++)
        q[p] = c[p];
      for (p = 0; p < 32; p++)
        for (A = 0; A < 32; A++)
          q[p + A] += i[p] * f[A];
      return At(t.subarray(32), q), Q;
    }
    function cr(t, n) {
      var r = s(), e = s(), f = s(), i = s(), c = s(), p = s(), A = s();
      return m(t[2], O), ze(t[1], n), Re(f, t[1]), Z(i, f, ce), ve(f, f, t[2]), ie(i, t[2], i), Re(c, i), Re(p, c), Z(A, p, c), Z(r, A, f), Z(r, r, i), Mt(r, r), Z(r, r, f), Z(r, r, i), Z(r, r, i), Z(t[0], r, i), Re(e, t[0]), Z(e, e, i), re(e, f) && Z(t[0], t[0], Ce), Re(e, t[0]), Z(e, e, i), re(e, f) ? -1 : (Ie(t[0]) === n[31] >> 7 && ve(t[0], D, t[0]), Z(t[3], t[0], t[1]), 0);
    }
    function _t(t, n, r, e) {
      var f, i = new Uint8Array(32), c = new Uint8Array(64), p = [s(), s(), s(), s()], A = [s(), s(), s(), s()];
      if (r < 64 || cr(A, e))
        return -1;
      for (f = 0; f < r; f++)
        t[f] = n[f];
      for (f = 0; f < 32; f++)
        t[f + 32] = e[f];
      if (Pe(c, t, r), St(c), gt(p, A, c), st(A, n.subarray(32)), at(p, A), vt(i, p), r -= 64, Le(n, 0, i, 0)) {
        for (f = 0; f < r; f++)
          t[f] = 0;
        return -1;
      }
      for (f = 0; f < r; f++)
        t[f] = n[f + 64];
      return r;
    }
    var Et = 32, ct = 24, Ye = 32, He = 16, Ve = 32, ut = 32, Ze = 32, Xe = 32, Rt = 32, Ft = ct, ur = Ye, dr = He, $e = 64, Me = 32, ke = 64, Dt = 32, Tt = 64;
    a.lowlevel = {
      crypto_core_hsalsa20: qe,
      crypto_stream_xor: Ke,
      crypto_stream: De,
      crypto_stream_salsa20_xor: et,
      crypto_stream_salsa20: tt,
      crypto_onetimeauth: Se,
      crypto_onetimeauth_verify: rt,
      crypto_verify_16: Oe,
      crypto_verify_32: Le,
      crypto_secretbox: Be,
      crypto_secretbox_open: h,
      crypto_scalarmult: nt,
      crypto_scalarmult_base: ft,
      crypto_box_beforenm: ot,
      crypto_box_afternm: jt,
      crypto_box: sr,
      crypto_box_open: ir,
      crypto_box_keypair: Lt,
      crypto_hash: Pe,
      crypto_sign: Jt,
      crypto_sign_keypair: mt,
      crypto_sign_open: _t,
      crypto_secretbox_KEYBYTES: Et,
      crypto_secretbox_NONCEBYTES: ct,
      crypto_secretbox_ZEROBYTES: Ye,
      crypto_secretbox_BOXZEROBYTES: He,
      crypto_scalarmult_BYTES: Ve,
      crypto_scalarmult_SCALARBYTES: ut,
      crypto_box_PUBLICKEYBYTES: Ze,
      crypto_box_SECRETKEYBYTES: Xe,
      crypto_box_BEFORENMBYTES: Rt,
      crypto_box_NONCEBYTES: Ft,
      crypto_box_ZEROBYTES: ur,
      crypto_box_BOXZEROBYTES: dr,
      crypto_sign_BYTES: $e,
      crypto_sign_PUBLICKEYBYTES: Me,
      crypto_sign_SECRETKEYBYTES: ke,
      crypto_sign_SEEDBYTES: Dt,
      crypto_hash_BYTES: Tt,
      gf: s,
      D: ce,
      L: it,
      pack25519: ae,
      unpack25519: ze,
      M: Z,
      A: ie,
      S: Re,
      Z: ve,
      pow2523: Mt,
      add: at,
      set25519: m,
      modL: At,
      scalarmult: gt,
      scalarbase: st
    };
    function Nt(t, n) {
      if (t.length !== Et)
        throw new Error("bad key size");
      if (n.length !== ct)
        throw new Error("bad nonce size");
    }
    function hr(t, n) {
      if (t.length !== Ze)
        throw new Error("bad public key size");
      if (n.length !== Xe)
        throw new Error("bad secret key size");
    }
    function _e() {
      for (var t = 0; t < arguments.length; t++)
        if (!(arguments[t] instanceof Uint8Array))
          throw new TypeError("unexpected type, use Uint8Array");
    }
    function Kt(t) {
      for (var n = 0; n < t.length; n++)
        t[n] = 0;
    }
    a.randomBytes = function(t) {
      var n = new Uint8Array(t);
      return b(n, t), n;
    }, a.secretbox = function(t, n, r) {
      _e(t, n, r), Nt(r, n);
      for (var e = new Uint8Array(Ye + t.length), f = new Uint8Array(e.length), i = 0; i < t.length; i++)
        e[i + Ye] = t[i];
      return Be(f, e, e.length, n, r), f.subarray(He);
    }, a.secretbox.open = function(t, n, r) {
      _e(t, n, r), Nt(r, n);
      for (var e = new Uint8Array(He + t.length), f = new Uint8Array(e.length), i = 0; i < t.length; i++)
        e[i + He] = t[i];
      return e.length < 32 || h(f, e, e.length, n, r) !== 0 ? null : f.subarray(Ye);
    }, a.secretbox.keyLength = Et, a.secretbox.nonceLength = ct, a.secretbox.overheadLength = He, a.scalarMult = function(t, n) {
      if (_e(t, n), t.length !== ut)
        throw new Error("bad n size");
      if (n.length !== Ve)
        throw new Error("bad p size");
      var r = new Uint8Array(Ve);
      return nt(r, t, n), r;
    }, a.scalarMult.base = function(t) {
      if (_e(t), t.length !== ut)
        throw new Error("bad n size");
      var n = new Uint8Array(Ve);
      return ft(n, t), n;
    }, a.scalarMult.scalarLength = ut, a.scalarMult.groupElementLength = Ve, a.box = function(t, n, r, e) {
      var f = a.box.before(r, e);
      return a.secretbox(t, n, f);
    }, a.box.before = function(t, n) {
      _e(t, n), hr(t, n);
      var r = new Uint8Array(Rt);
      return ot(r, t, n), r;
    }, a.box.after = a.secretbox, a.box.open = function(t, n, r, e) {
      var f = a.box.before(r, e);
      return a.secretbox.open(t, n, f);
    }, a.box.open.after = a.secretbox.open, a.box.keyPair = function() {
      var t = new Uint8Array(Ze), n = new Uint8Array(Xe);
      return Lt(t, n), { publicKey: t, secretKey: n };
    }, a.box.keyPair.fromSecretKey = function(t) {
      if (_e(t), t.length !== Xe)
        throw new Error("bad secret key size");
      var n = new Uint8Array(Ze);
      return ft(n, t), { publicKey: n, secretKey: new Uint8Array(t) };
    }, a.box.publicKeyLength = Ze, a.box.secretKeyLength = Xe, a.box.sharedKeyLength = Rt, a.box.nonceLength = Ft, a.box.overheadLength = a.secretbox.overheadLength, a.sign = function(t, n) {
      if (_e(t, n), n.length !== ke)
        throw new Error("bad secret key size");
      var r = new Uint8Array($e + t.length);
      return Jt(r, t, t.length, n), r;
    }, a.sign.open = function(t, n) {
      if (_e(t, n), n.length !== Me)
        throw new Error("bad public key size");
      var r = new Uint8Array(t.length), e = _t(r, t, t.length, n);
      if (e < 0)
        return null;
      for (var f = new Uint8Array(e), i = 0; i < f.length; i++)
        f[i] = r[i];
      return f;
    }, a.sign.detached = function(t, n) {
      for (var r = a.sign(t, n), e = new Uint8Array($e), f = 0; f < e.length; f++)
        e[f] = r[f];
      return e;
    }, a.sign.detached.verify = function(t, n, r) {
      if (_e(t, n, r), n.length !== $e)
        throw new Error("bad signature size");
      if (r.length !== Me)
        throw new Error("bad public key size");
      var e = new Uint8Array($e + t.length), f = new Uint8Array($e + t.length), i;
      for (i = 0; i < $e; i++)
        e[i] = n[i];
      for (i = 0; i < t.length; i++)
        e[i + $e] = t[i];
      return _t(f, e, e.length, r) >= 0;
    }, a.sign.keyPair = function() {
      var t = new Uint8Array(Me), n = new Uint8Array(ke);
      return mt(t, n), { publicKey: t, secretKey: n };
    }, a.sign.keyPair.fromSecretKey = function(t) {
      if (_e(t), t.length !== ke)
        throw new Error("bad secret key size");
      for (var n = new Uint8Array(Me), r = 0; r < n.length; r++)
        n[r] = t[32 + r];
      return { publicKey: n, secretKey: new Uint8Array(t) };
    }, a.sign.keyPair.fromSeed = function(t) {
      if (_e(t), t.length !== Dt)
        throw new Error("bad seed size");
      for (var n = new Uint8Array(Me), r = new Uint8Array(ke), e = 0; e < 32; e++)
        r[e] = t[e];
      return mt(n, r, !0), { publicKey: n, secretKey: r };
    }, a.sign.publicKeyLength = Me, a.sign.secretKeyLength = ke, a.sign.seedLength = Dt, a.sign.signatureLength = $e, a.hash = function(t) {
      _e(t);
      var n = new Uint8Array(Tt);
      return Pe(n, t, t.length), n;
    }, a.hash.hashLength = Tt, a.verify = function(t, n) {
      return _e(t, n), t.length === 0 || n.length === 0 || t.length !== n.length ? !1 : oe(t, 0, n, 0, t.length) === 0;
    }, a.setPRNG = function(t) {
      b = t;
    }, function() {
      var t = typeof self < "u" ? self.crypto || self.msCrypto : null;
      if (t && t.getRandomValues) {
        var n = 65536;
        a.setPRNG(function(r, e) {
          var f, i = new Uint8Array(e);
          for (f = 0; f < e; f += n)
            t.getRandomValues(i.subarray(f, f + Math.min(e - f, n)));
          for (f = 0; f < e; f++)
            r[f] = i[f];
          Kt(i);
        });
      } else
        typeof wr < "u" && (t = xr(), t && t.randomBytes && a.setPRNG(function(r, e) {
          var f, i = t.randomBytes(e);
          for (f = 0; f < e; f++)
            r[f] = i[f];
          Kt(i);
        }));
    }();
  })(x.exports ? x.exports : self.nacl = self.nacl || {});
})(Xt);
var Je = Xt.exports;
class It {
  buffer;
  currentOffset;
  constructor(a) {
    this.buffer = a, this.currentOffset = 0;
  }
  static withSize(a) {
    const s = new Uint8Array(a);
    return new It(s);
  }
  extend(a) {
    const s = this.currentOffset + a.length;
    if (s > this.buffer.byteLength) {
      const b = this.buffer;
      this.buffer = new Uint8Array(s * 2), this.buffer.set(b);
    }
    this.buffer.set(a, this.currentOffset), this.currentOffset += a.length;
  }
  reset() {
    this.currentOffset = 0;
  }
  view(a = !1) {
    const s = this.buffer.subarray(0, this.currentOffset);
    return a ? s.slice() : s;
  }
  size() {
    return this.currentOffset;
  }
}
var vr = /* @__PURE__ */ ((x) => (x.ExportDataset = "EXPORT_DATASET", x.ExportDcrJobResult = "EXPORT_DCR_JOB_RESULT", x.ImportDataset = "IMPORT_DATASET", x))(vr || {}), gr = /* @__PURE__ */ ((x) => (x.Azure = "AZURE", x.Compute = "COMPUTE", x.Databricks = "DATABRICKS", x.GoogleCloudStorage = "GOOGLE_CLOUD_STORAGE", x.Local = "LOCAL", x.Permutive = "PERMUTIVE", x.S3 = "S3", x.Salesforce = "SALESFORCE", x.Snowflake = "SNOWFLAKE", x))(gr || {}), mr = /* @__PURE__ */ ((x) => (x.Adform = "ADFORM", x.Azure = "AZURE", x.GoogleAds = "GOOGLE_ADS", x.GoogleAdManager = "GOOGLE_AD_MANAGER", x.GoogleCloudStorage = "GOOGLE_CLOUD_STORAGE", x.GoogleDv_360 = "GOOGLE_DV_360", x.Meta = "META", x.MicrosoftDsp = "MICROSOFT_DSP", x.Permutive = "PERMUTIVE", x.S3 = "S3", x.Snapchat = "SNAPCHAT", x.Splicky = "SPLICKY", x.Sportradar = "SPORTRADAR", x.Tiktok = "TIKTOK", x.TradeDesk = "TRADE_DESK", x))(mr || {});
class se extends String {
  constructor(a, s) {
    super(a), this.value = a, this.__meta__ = s;
  }
  __apiType;
  toString() {
    return this.value;
  }
}
const Ar = new se(`
    query GetAttestationSpecsV2 {
  attestationSpecsV2 {
    name
    version
    spec
  }
}
    `), Sr = new se(`
    mutation GetOrCreateDatasetScope($input: CreateDatasetScopeInput!) {
  scope {
    getOrCreateDatasetScope(input: $input) {
      record {
        id
      }
    }
  }
}
    `), _r = new se(`
    mutation GetOrCreateDcrDataScope($input: CreateDcrDataScopeInput!) {
  scope {
    getOrCreateDcrDataScope(input: $input) {
      record {
        id
      }
    }
  }
}
    `), Er = new se(`
    mutation CreateUpload {
  upload {
    create {
      record {
        id
      }
    }
  }
}
    `), Rr = new se(`
    mutation FinalizeUpload($input: CreateDatasetForUploadInput!) {
  upload {
    finalizeUploadAndCreateDataset(input: $input) {
      record {
        id
        manifestHash
      }
    }
  }
}
    `), Dr = new se(`
    query GetDataset($manifestHash: HexString!) {
  datasetByManifestHash(manifestHash: $manifestHash) {
    id
    name
    manifestHash
    statistics
    size
    description
    createdAt
    usage
    datasetImport {
      dataRoomId
    }
    encryptionKeySecretId
    metadataSecretId
  }
}
    `), Tr = new se(`
    query GetAvailableDatasets {
  myself {
    datasets {
      nodes {
        id
        name
        manifestHash
        statistics
        size
        description
        createdAt
        usage
        encryptionKeySecretId
        metadataSecretId
      }
    }
  }
}
    `), Cr = new se(`
    mutation DeleteDataset($manifestHash: HexString!) {
  dataset {
    deleteByManifestHash(manifestHash: $manifestHash)
  }
}
    `), Ur = new se(`
    mutation CreateApiToken($input: CreateApiTokenInput!) {
  apiToken {
    create(input: $input) {
      id
      token
      name
      description
      revoked
      createdAt
    }
  }
}
    `), Or = new se(`
    query getAllApiTokens {
  myself {
    apiTokens {
      nodes {
        id
        token
        name
        description
        revoked
        createdAt
      }
    }
  }
}
    `), $r = new se(`
    mutation RevokeApiToken($id: String!) {
  apiToken {
    revoke(id: $id) {
      id
    }
  }
}
    `), qr = new se(`
    query getCertificateAuthority {
  certificateAuthority {
    rootCertificate
  }
}
    `), Br = new se(`
    query GetPublishedDataRoom($dataRoomHash: String!) {
  publishedDataRoom(id: $dataRoomHash) {
    id
    title
    driverAttestationHash
    isStopped
    createdAt
    updatedAt
  }
}
    `), Ir = new se(`
    query getUserCertificate($input: UserCsrInput!) {
  certificateAuthority {
    userCertificate(input: $input)
  }
}
    `), Pr = new se(`
    query GetScope($scopeId: String!) {
  scope(id: $scopeId) {
    id
    organization {
      id
      name
    }
    owner {
      id
      email
    }
    scopeType
    manifestHash
    dataRoomHash
    createdAt
  }
}
    `), Mr = new se(`
    mutation SetJobIdForDataConnectorJob($input: SetJobIdForDataConnectorJobInput!) {
  dataConnectorJob {
    setJobId(input: $input) {
      record {
        id
      }
    }
  }
}
    `), Lr = new se(`
    mutation SetDataConnectorJobToFailed($id: String!) {
  dataConnectorJob {
    setJobToFailed(id: $id) {
      record {
        id
      }
    }
  }
}
    `), jr = new se(`
    mutation SetDataConnectorJobToSuccess($id: String!) {
  dataConnectorJob {
    setJobToSuccess(id: $id) {
      record {
        id
      }
    }
  }
}
    `), Gr = new se(`
    query GetDataConnectorJob($id: String!) {
  dataConnectorJob(id: $id) {
    name
    type
    computeJobId
    computeJobNode
    dataRoomId
    driverAttestationHash
  }
}
    `), Hr = new se(`
    mutation CreateDataConnectorJob($input: CreateDataConnectorJobInput!) {
  dataConnectorJob {
    create(input: $input) {
      record {
        id
      }
    }
  }
}
    `), kr = new se(`
    mutation SetDataLabJobIds($input: SetDataLabJobIdsInput!) {
  dataLab {
    setJobIds(input: $input) {
      record {
        id
      }
    }
  }
}
    `), Jr = new se(`
    mutation CreateDataLab($input: CreateDataLabInput!) {
  dataLab {
    create(input: $input) {
      record {
        id
        highLevelRepresentationAsString
      }
    }
  }
}
    `), Fr = new se(`
    query GetDataLab($id: String!) {
  dataLab(id: $id) {
    highLevelRepresentationAsString
  }
}
    `), Nr = new se(`
    query MicrosoftDspMemberFromOrganisation {
  myself {
    organization {
      microsoftDspMember
    }
  }
}
    `), Kr = new se(`
    mutation CreateSession($input: CreateSessionInput!) {
  session {
    create(input: $input) {
      record {
        id
        fatquote
      }
    }
  }
}
    `), zr = {
  "\n      query GetAttestationSpecsV2 {\n        attestationSpecsV2 {\n          name\n          version\n          spec\n        }\n      }\n    ": Ar,
  "\n      mutation GetOrCreateDatasetScope($input: CreateDatasetScopeInput!) {\n        scope {\n          getOrCreateDatasetScope(input: $input) {\n            record {\n              id\n            }\n          }\n        }\n      }\n    ": Sr,
  "\n      mutation GetOrCreateDcrDataScope($input: CreateDcrDataScopeInput!) {\n        scope {\n          getOrCreateDcrDataScope(input: $input) {\n            record {\n              id\n            }\n          }\n        }\n      }\n    ": _r,
  "\n      mutation CreateUpload {\n        upload {\n          create {\n            record {\n              id\n            }\n          }\n        }\n      }\n    ": Er,
  "\n      mutation FinalizeUpload($input: CreateDatasetForUploadInput!) {\n        upload {\n          finalizeUploadAndCreateDataset(input: $input) {\n            record {\n              id\n              manifestHash\n            }\n          }\n        }\n      }\n    ": Rr,
  "\n      query GetDataset($manifestHash: HexString!) {\n        datasetByManifestHash(manifestHash: $manifestHash) {\n          id\n          name\n          manifestHash\n          statistics\n          size\n          description\n          createdAt\n          usage\n          datasetImport {\n            dataRoomId\n          }\n          encryptionKeySecretId\n          metadataSecretId\n        }\n      }\n    ": Dr,
  "\n      query GetAvailableDatasets {\n        myself {\n          datasets {\n            nodes {\n              id\n              name\n              manifestHash\n              statistics\n              size\n              description\n              createdAt\n              usage\n              encryptionKeySecretId\n              metadataSecretId\n            }\n          }\n        }\n      }\n    ": Tr,
  "\n      mutation DeleteDataset($manifestHash: HexString!) {\n        dataset {\n          deleteByManifestHash(manifestHash: $manifestHash)\n        }\n      }\n    ": Cr,
  "\n      mutation CreateApiToken($input: CreateApiTokenInput!) {\n        apiToken {\n          create(input: $input) {\n            id\n            token\n            name\n            description\n            revoked\n            createdAt\n          }\n        }\n      }\n    ": Ur,
  "\n        query getAllApiTokens {\n          myself {\n            apiTokens {\n              nodes {\n                id\n                token\n                name\n                description\n                revoked\n                createdAt\n              }\n            }\n          }\n        }\n      ": Or,
  "\n        mutation RevokeApiToken($id: String!) {\n          apiToken {\n            revoke(id: $id) {\n              id\n            }\n          }\n        }\n      ": $r,
  "\n        query getCertificateAuthority {\n          certificateAuthority {\n            rootCertificate\n          }\n        }\n      ": qr,
  "\n        query GetPublishedDataRoom($dataRoomHash: String!) {\n          publishedDataRoom(id: $dataRoomHash) {\n            id\n            title\n            driverAttestationHash\n            isStopped\n            createdAt\n            updatedAt\n          }\n        }\n      ": Br,
  "\n        query getUserCertificate($input: UserCsrInput!) {\n          certificateAuthority {\n            userCertificate(input: $input)\n          }\n        }\n      ": Ir,
  "\n        query GetScope($scopeId: String!) {\n          scope(id: $scopeId) {\n            id\n            organization {\n              id\n              name\n            }\n            owner {\n              id\n              email\n            }\n            scopeType\n            manifestHash\n            dataRoomHash\n            # driverAttestationHash\n            createdAt\n          }\n        }\n      ": Pr,
  "\n      mutation SetJobIdForDataConnectorJob(\n        $input: SetJobIdForDataConnectorJobInput!\n      ) {\n        dataConnectorJob {\n          setJobId(input: $input) {\n            record {\n              id\n            }\n          }\n        }\n      }\n    ": Mr,
  "\n      mutation SetDataConnectorJobToFailed($id: String!) {\n        dataConnectorJob {\n          setJobToFailed(id: $id) {\n            record {\n              id\n            }\n          }\n        }\n      }\n    ": Lr,
  "\n      mutation SetDataConnectorJobToSuccess($id: String!) {\n        dataConnectorJob {\n          setJobToSuccess(id: $id) {\n            record {\n              id\n            }\n          }\n        }\n      }\n    ": jr,
  "\n      query GetDataConnectorJob($id: String!) {\n        dataConnectorJob(id: $id) {\n          name\n          type\n          computeJobId\n          computeJobNode\n          dataRoomId\n          driverAttestationHash\n        }\n      }\n    ": Gr,
  "\n      mutation CreateDataConnectorJob($input: CreateDataConnectorJobInput!) {\n        dataConnectorJob {\n          create(input: $input) {\n            record {\n              id\n            }\n          }\n        }\n      }\n    ": Hr,
  "\n      mutation SetDataLabJobIds($input: SetDataLabJobIdsInput!) {\n        dataLab {\n          setJobIds(input: $input) {\n            record {\n              id\n            }\n          }\n        }\n      }\n    ": kr,
  "\n      mutation CreateDataLab($input: CreateDataLabInput!) {\n        dataLab {\n          create(input: $input) {\n            record {\n              id\n              highLevelRepresentationAsString\n            }\n          }\n        }\n      }\n    ": Jr,
  "\n      query GetDataLab($id: String!) {\n        dataLab(id: $id) {\n          highLevelRepresentationAsString\n        }\n      }\n    ": Fr,
  "\n    query MicrosoftDspMemberFromOrganisation {\n      myself {\n        organization {\n          microsoftDspMember\n        }\n      }\n    }\n  ": Nr,
  "\n        mutation CreateSession($input: CreateSessionInput!) {\n          session {\n            create(input: $input) {\n              record {\n                id\n                fatquote\n              }\n            }\n          }\n        }\n      ": Kr
};
function Yr(x) {
  return zr[x] ?? {};
}
var Ut = {}, pt = {};
Object.defineProperty(pt, "__esModule", { value: !0 });
pt.coalesceAsync = void 0;
const Qe = /* @__PURE__ */ new Map();
async function Vr(x, a) {
  if (!Zr(x)) {
    Xr(x);
    try {
      const s = await Promise.resolve(a());
      return Zt({ key: x, result: s }), s;
    } catch (s) {
      throw Zt({ key: x, error: s }), s;
    }
  }
  return en(x);
}
pt.coalesceAsync = Vr;
function Zr(x) {
  return Qe.has(x);
}
function Xr(x) {
  Qe.set(x, []);
}
function Wr(x) {
  Qe.delete(x);
}
function Qr(x, a) {
  const s = Wt(x);
  s.push(a), Qe.set(x, s);
}
function Wt(x) {
  return Qe.get(x) ?? [];
}
function en(x) {
  return new Promise((a, s) => {
    Qr(x, { resolve: a, reject: s });
  });
}
function tn(x) {
  const a = Wt(x);
  return Wr(x), a;
}
function Zt(x) {
  const { key: a, error: s, result: b } = x;
  tn(a).forEach((v) => {
    s ? v.reject(s) : v.resolve(b);
  });
}
(function(x) {
  var a = Ne && Ne.__createBinding || (Object.create ? function(b, v, U, D) {
    D === void 0 && (D = U);
    var O = Object.getOwnPropertyDescriptor(v, U);
    (!O || ("get" in O ? !v.__esModule : O.writable || O.configurable)) && (O = { enumerable: !0, get: function() {
      return v[U];
    } }), Object.defineProperty(b, D, O);
  } : function(b, v, U, D) {
    D === void 0 && (D = U), b[D] = v[U];
  }), s = Ne && Ne.__exportStar || function(b, v) {
    for (var U in b)
      U !== "default" && !Object.prototype.hasOwnProperty.call(v, U) && a(v, b, U);
  };
  Object.defineProperty(x, "__esModule", { value: !0 }), s(pt, x);
})(Ut);
var Ot = { exports: {} };
(function(x, a) {
  var s = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof Ne < "u" && Ne, b = function() {
    function U() {
      this.fetch = !1, this.DOMException = s.DOMException;
    }
    return U.prototype = s, new U();
  }();
  (function(U) {
    (function(D) {
      var O = typeof U < "u" && U || typeof self < "u" && self || typeof O < "u" && O, H = {
        searchParams: "URLSearchParams" in O,
        iterable: "Symbol" in O && "iterator" in Symbol,
        blob: "FileReader" in O && "Blob" in O && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in O,
        arrayBuffer: "ArrayBuffer" in O
      };
      function ce(h) {
        return h && DataView.prototype.isPrototypeOf(h);
      }
      if (H.arrayBuffer)
        var ye = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], le = ArrayBuffer.isView || function(h) {
          return h && ye.indexOf(Object.prototype.toString.call(h)) > -1;
        };
      function we(h) {
        if (typeof h != "string" && (h = String(h)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(h) || h === "")
          throw new TypeError('Invalid character in header field name: "' + h + '"');
        return h.toLowerCase();
      }
      function Ce(h) {
        return typeof h != "string" && (h = String(h)), h;
      }
      function Ue(h) {
        var m = {
          next: function() {
            var J = h.shift();
            return { done: J === void 0, value: J };
          }
        };
        return H.iterable && (m[Symbol.iterator] = function() {
          return m;
        }), m;
      }
      function oe(h) {
        this.map = {}, h instanceof oe ? h.forEach(function(m, J) {
          this.append(J, m);
        }, this) : Array.isArray(h) ? h.forEach(function(m) {
          this.append(m[0], m[1]);
        }, this) : h && Object.getOwnPropertyNames(h).forEach(function(m) {
          this.append(m, h[m]);
        }, this);
      }
      oe.prototype.append = function(h, m) {
        h = we(h), m = Ce(m);
        var J = this.map[h];
        this.map[h] = J ? J + ", " + m : m;
      }, oe.prototype.delete = function(h) {
        delete this.map[we(h)];
      }, oe.prototype.get = function(h) {
        return h = we(h), this.has(h) ? this.map[h] : null;
      }, oe.prototype.has = function(h) {
        return this.map.hasOwnProperty(we(h));
      }, oe.prototype.set = function(h, m) {
        this.map[we(h)] = Ce(m);
      }, oe.prototype.forEach = function(h, m) {
        for (var J in this.map)
          this.map.hasOwnProperty(J) && h.call(m, this.map[J], J, this);
      }, oe.prototype.keys = function() {
        var h = [];
        return this.forEach(function(m, J) {
          h.push(J);
        }), Ue(h);
      }, oe.prototype.values = function() {
        var h = [];
        return this.forEach(function(m) {
          h.push(m);
        }), Ue(h);
      }, oe.prototype.entries = function() {
        var h = [];
        return this.forEach(function(m, J) {
          h.push([J, m]);
        }), Ue(h);
      }, H.iterable && (oe.prototype[Symbol.iterator] = oe.prototype.entries);
      function Oe(h) {
        if (h.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        h.bodyUsed = !0;
      }
      function Le(h) {
        return new Promise(function(m, J) {
          h.onload = function() {
            m(h.result);
          }, h.onerror = function() {
            J(h.error);
          };
        });
      }
      function bt(h) {
        var m = new FileReader(), J = Le(m);
        return m.readAsArrayBuffer(h), J;
      }
      function wt(h) {
        var m = new FileReader(), J = Le(m);
        return m.readAsText(h), J;
      }
      function je(h) {
        for (var m = new Uint8Array(h), J = new Array(m.length), ne = 0; ne < m.length; ne++)
          J[ne] = String.fromCharCode(m[ne]);
        return J.join("");
      }
      function qe(h) {
        if (h.slice)
          return h.slice(0);
        var m = new Uint8Array(h.byteLength);
        return m.set(new Uint8Array(h)), m.buffer;
      }
      function Te() {
        return this.bodyUsed = !1, this._initBody = function(h) {
          this.bodyUsed = this.bodyUsed, this._bodyInit = h, h ? typeof h == "string" ? this._bodyText = h : H.blob && Blob.prototype.isPrototypeOf(h) ? this._bodyBlob = h : H.formData && FormData.prototype.isPrototypeOf(h) ? this._bodyFormData = h : H.searchParams && URLSearchParams.prototype.isPrototypeOf(h) ? this._bodyText = h.toString() : H.arrayBuffer && H.blob && ce(h) ? (this._bodyArrayBuffer = qe(h.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : H.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(h) || le(h)) ? this._bodyArrayBuffer = qe(h) : this._bodyText = h = Object.prototype.toString.call(h) : this._bodyText = "", this.headers.get("content-type") || (typeof h == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : H.searchParams && URLSearchParams.prototype.isPrototypeOf(h) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, H.blob && (this.blob = function() {
          var h = Oe(this);
          if (h)
            return h;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          if (this._bodyArrayBuffer) {
            var h = Oe(this);
            return h || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
              this._bodyArrayBuffer.buffer.slice(
                this._bodyArrayBuffer.byteOffset,
                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
              )
            ) : Promise.resolve(this._bodyArrayBuffer));
          } else
            return this.blob().then(bt);
        }), this.text = function() {
          var h = Oe(this);
          if (h)
            return h;
          if (this._bodyBlob)
            return wt(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(je(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, H.formData && (this.formData = function() {
          return this.text().then(Ke);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var et = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function tt(h) {
        var m = h.toUpperCase();
        return et.indexOf(m) > -1 ? m : h;
      }
      function De(h, m) {
        if (!(this instanceof De))
          throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        m = m || {};
        var J = m.body;
        if (h instanceof De) {
          if (h.bodyUsed)
            throw new TypeError("Already read");
          this.url = h.url, this.credentials = h.credentials, m.headers || (this.headers = new oe(h.headers)), this.method = h.method, this.mode = h.mode, this.signal = h.signal, !J && h._bodyInit != null && (J = h._bodyInit, h.bodyUsed = !0);
        } else
          this.url = String(h);
        if (this.credentials = m.credentials || this.credentials || "same-origin", (m.headers || !this.headers) && (this.headers = new oe(m.headers)), this.method = tt(m.method || this.method || "GET"), this.mode = m.mode || this.mode || null, this.signal = m.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && J)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        if (this._initBody(J), (this.method === "GET" || this.method === "HEAD") && (m.cache === "no-store" || m.cache === "no-cache")) {
          var ne = /([?&])_=[^&]*/;
          if (ne.test(this.url))
            this.url = this.url.replace(ne, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
          else {
            var ae = /\?/;
            this.url += (ae.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
          }
        }
      }
      De.prototype.clone = function() {
        return new De(this, { body: this._bodyInit });
      };
      function Ke(h) {
        var m = new FormData();
        return h.trim().split("&").forEach(function(J) {
          if (J) {
            var ne = J.split("="), ae = ne.shift().replace(/\+/g, " "), re = ne.join("=").replace(/\+/g, " ");
            m.append(decodeURIComponent(ae), decodeURIComponent(re));
          }
        }), m;
      }
      function Ge(h) {
        var m = new oe(), J = h.replace(/\r?\n[\t ]+/g, " ");
        return J.split("\r").map(function(ne) {
          return ne.indexOf(`
`) === 0 ? ne.substr(1, ne.length) : ne;
        }).forEach(function(ne) {
          var ae = ne.split(":"), re = ae.shift().trim();
          if (re) {
            var Ie = ae.join(":").trim();
            m.append(re, Ie);
          }
        }), m;
      }
      Te.call(De.prototype);
      function Se(h, m) {
        if (!(this instanceof Se))
          throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        m || (m = {}), this.type = "default", this.status = m.status === void 0 ? 200 : m.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = m.statusText === void 0 ? "" : "" + m.statusText, this.headers = new oe(m.headers), this.url = m.url || "", this._initBody(h);
      }
      Te.call(Se.prototype), Se.prototype.clone = function() {
        return new Se(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new oe(this.headers),
          url: this.url
        });
      }, Se.error = function() {
        var h = new Se(null, { status: 0, statusText: "" });
        return h.type = "error", h;
      };
      var rt = [301, 302, 303, 307, 308];
      Se.redirect = function(h, m) {
        if (rt.indexOf(m) === -1)
          throw new RangeError("Invalid status code");
        return new Se(null, { status: m, headers: { location: h } });
      }, D.DOMException = O.DOMException;
      try {
        new D.DOMException();
      } catch {
        D.DOMException = function(m, J) {
          this.message = m, this.name = J;
          var ne = Error(m);
          this.stack = ne.stack;
        }, D.DOMException.prototype = Object.create(Error.prototype), D.DOMException.prototype.constructor = D.DOMException;
      }
      function Be(h, m) {
        return new Promise(function(J, ne) {
          var ae = new De(h, m);
          if (ae.signal && ae.signal.aborted)
            return ne(new D.DOMException("Aborted", "AbortError"));
          var re = new XMLHttpRequest();
          function Ie() {
            re.abort();
          }
          re.onload = function() {
            var ie = {
              status: re.status,
              statusText: re.statusText,
              headers: Ge(re.getAllResponseHeaders() || "")
            };
            ie.url = "responseURL" in re ? re.responseURL : ie.headers.get("X-Request-URL");
            var ve = "response" in re ? re.response : re.responseText;
            setTimeout(function() {
              J(new Se(ve, ie));
            }, 0);
          }, re.onerror = function() {
            setTimeout(function() {
              ne(new TypeError("Network request failed"));
            }, 0);
          }, re.ontimeout = function() {
            setTimeout(function() {
              ne(new TypeError("Network request failed"));
            }, 0);
          }, re.onabort = function() {
            setTimeout(function() {
              ne(new D.DOMException("Aborted", "AbortError"));
            }, 0);
          };
          function ze(ie) {
            try {
              return ie === "" && O.location.href ? O.location.href : ie;
            } catch {
              return ie;
            }
          }
          re.open(ae.method, ze(ae.url), !0), ae.credentials === "include" ? re.withCredentials = !0 : ae.credentials === "omit" && (re.withCredentials = !1), "responseType" in re && (H.blob ? re.responseType = "blob" : H.arrayBuffer && ae.headers.get("Content-Type") && ae.headers.get("Content-Type").indexOf("application/octet-stream") !== -1 && (re.responseType = "arraybuffer")), m && typeof m.headers == "object" && !(m.headers instanceof oe) ? Object.getOwnPropertyNames(m.headers).forEach(function(ie) {
            re.setRequestHeader(ie, Ce(m.headers[ie]));
          }) : ae.headers.forEach(function(ie, ve) {
            re.setRequestHeader(ve, ie);
          }), ae.signal && (ae.signal.addEventListener("abort", Ie), re.onreadystatechange = function() {
            re.readyState === 4 && ae.signal.removeEventListener("abort", Ie);
          }), re.send(typeof ae._bodyInit > "u" ? null : ae._bodyInit);
        });
      }
      return Be.polyfill = !0, O.fetch || (O.fetch = Be, O.Headers = oe, O.Request = De, O.Response = Se), D.Headers = oe, D.Request = De, D.Response = Se, D.fetch = Be, D;
    })({});
  })(b), b.fetch.ponyfill = !0, delete b.fetch.polyfill;
  var v = s.fetch ? s : b;
  a = v.fetch, a.default = v.fetch, a.fetch = v.fetch, a.Headers = v.Headers, a.Request = v.Request, a.Response = v.Response, x.exports = a;
})(Ot, Ot.exports);
var rn = Ot.exports;
const nn = /* @__PURE__ */ pr(rn);
class fn {
  constructor(a, s) {
    this.platformToken = a, this.enclaveToken = s, this.type = "user";
  }
  type;
}
function on(x) {
  return be.util.binary.base64.decode(
    x.replaceAll("-", "+").replaceAll("_", "/")
  );
}
function an(x) {
  return be.util.binary.base64.encode(x).replaceAll("+", "-").replaceAll("/", "_");
}
class sn {
  constructor(a) {
    this.enclaveToken = a, this.type = "app";
    const s = on(a), b = be.util.binary.raw.decode(
      be.md.sha256.create().update(be.util.binary.raw.encode(s)).digest().getBytes()
    );
    this.platformToken = an(b);
  }
  type;
  platformToken;
}
var xt = /* @__PURE__ */ ((x) => (x.GRAPHQL = "graphql", x.SESSION_MESSAGES = "sessions/:sessionId/messages", x.SESSION_MESSAGES_V2 = "sessions/:sessionId/messages_v2", x.USER_UPLOAD_CHUNKS = "uploads/:uploadId/chunks/:chunkHash", x))(xt || {});
class yt extends Error {
  constructor(a, s) {
    super(a), this.originalErrors = s, Object.setPrototypeOf(this, yt.prototype);
  }
}
class cn {
  prefixUrl;
  headers;
  fetch;
  constructor(a, s, b, v, U, {
    apiPrefix: D = "",
    additionalAuthHeaders: O = {},
    fetch: H = nn
  } = {}) {
    const ce = U ? "https" : "http", ye = {
      Authorization: `Bearer ${a.platformToken}`,
      "Authorization-Client": s,
      "Authorization-Type": a.type
    };
    this.prefixUrl = `${ce}://${b}:${v}${D}`, this.headers = { ...ye, ...O }, this.fetch = H.bind(globalThis);
  }
  async makeRequest({
    endpoint: a,
    method: s,
    reqBody: b,
    headers: v = {},
    options: U = {}
  }) {
    const D = `${this.prefixUrl}/${a}`, O = or({
      backoffFactor: Vt.requestRetryBackoffFactor,
      total: U.retry ? Vt.requestRetryTotal : 1
    }), H = [];
    for await (const ce of O) {
      const ye = `Failed to ${s} to ${D}, re-attempt ${ce}`;
      try {
        const le = await this.fetch.call(globalThis, D, {
          body: b,
          headers: { ...this.headers, ...v },
          method: s
        });
        if (le.status === 408 || le.status === 429 || le.status >= 500) {
          const we = await le.text();
          H.push(we), console.warn(`${ye} [code ${le.status}]: ${we}`);
          continue;
        } else
          return le;
      } catch (le) {
        H.push(`${le}`), console.warn(ye + ": " + le);
        continue;
      }
    }
    throw new yt(
      `Failed to ${s} to ${D}, maximum re-attempts reached. Latest error: ${H.slice(-1)[0]}`,
      H
    );
  }
  async post(a) {
    return this.makeRequest({ ...a, method: "POST" });
  }
  async put(a) {
    return this.makeRequest({ ...a, method: "PUT" });
  }
  async patch(a) {
    return this.makeRequest({ ...a, method: "PATCH" });
  }
  async get(a) {
    return this.makeRequest({ ...a, method: "GET" });
  }
  async head(a) {
    return this.makeRequest({ ...a, method: "HEAD" });
  }
  async delete(a) {
    return this.makeRequest({ ...a, method: "DELETE" });
  }
}
const Dn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: cn,
  AppToken: sn,
  ClientApiError: yt,
  Endpoints: xt,
  UserToken: fn
}, Symbol.toStringTag, { value: "Module" }));
function un(x, a, s) {
  return Fe.DataNoncePubkey.create({
    data: x,
    nonce: a,
    pubkey: s
  });
}
function dn(x) {
  const a = Fe.DataNoncePubkey.decodeDelimited(x);
  return {
    data: a.data,
    nonce: a.nonce,
    pubkey: a.pubkey
  };
}
class We extends Error {
  constructor(a) {
    super(a), Object.setPrototypeOf(this, We.prototype);
  }
}
class Qt {
  sessionId;
  api;
  enclavePublicKey;
  logRequests;
  channelKeyPair;
  constructor(a, s, b, v) {
    this.api = a, this.enclavePublicKey = s, this.logRequests = v, this.sessionId = b, this.channelKeyPair = Je.box.keyPair();
  }
  static async create({
    api: a,
    graphql: s,
    logRequests: b,
    driverAttestationSpecification: v,
    attestationSpecificationHash: U,
    unsafeDisableKnownRootCaCheck: D
  }) {
    const O = await s.post({
      query: Yr(`
        mutation CreateSession($input: CreateSessionInput!) {
          session {
            create(input: $input) {
              record {
                id
                fatquote
              }
            }
          }
        }
      `),
      variables: {
        input: {
          enclaveAttestationHash: U
        }
      }
    }), H = O.session.create.record.id, ce = be.util.binary.base64.decode(
      O.session.create.record.fatquote
    ), ye = Bt.Fatquote.decodeDelimited(ce), le = new yr(v);
    D && le.disableKnownRootCaCheck();
    const Ce = (await le.verify(ye)).slice(0, 32);
    return new Qt(a, Ce, H, b);
  }
  encryptAndEncode(a) {
    const s = Je.randomBytes(Je.box.nonceLength), b = Je.box(
      a,
      s,
      this.enclavePublicKey,
      this.channelKeyPair.secretKey
    );
    return un(
      b,
      s,
      this.channelKeyPair.publicKey
    );
  }
  decodeAndDecrypt(a) {
    const s = dn(a);
    return Je.box.open(
      s.data,
      s.nonce,
      this.enclavePublicKey,
      this.channelKeyPair.secretKey
    );
  }
  getUserAuth(a) {
    const s = Je.scalarMult(
      this.channelKeyPair.secretKey,
      this.enclavePublicKey
    ), b = tr(
      64,
      s,
      new Uint8Array(0),
      be.util.binary.raw.decode("IdP KDF Context")
    ), v = lt(
      b,
      new TextEncoder().encode(a.getUserId())
    ), U = new Uint8Array([
      ...this.channelKeyPair.publicKey,
      ...this.enclavePublicKey
    ]), D = a.sign(U), O = new br(D, v, a), H = Ee.Pki.create({
      certChainPem: O.getCertChain(),
      idMac: O.getMacTag(),
      signature: O.getSignature()
    });
    return Ee.UserAuth.create({
      enclaveEndorsements: a.endorsements,
      pki: H
    });
  }
  async sendRequest(a, s, b) {
    if (this.logRequests) {
      const D = a.toJSON();
      for (const O of Object.getOwnPropertyNames(D))
        if (O.endsWith("Request")) {
          let H = `[enclave request] ${O}`;
          const ce = D[O].dataRoomId;
          ce && (H += ` | DCR: ${fr(ce)}`), console.info(H);
        }
    }
    a.userAuth = this.getUserAuth(b);
    const v = Ee.GcgRequest.encodeDelimited(a).finish();
    return (await this.sendRequestRaw(
      v,
      s
    )).map((D) => {
      const O = Ee.GcgResponse.decodeDelimited(D);
      if (O.failure)
        throw console.error(a, O), new We(`${O.failure}`);
      return O;
    });
  }
  async sendRequestRaw(a, s) {
    const b = be.md.sha256.create();
    b.update($t(a));
    const v = b.digest().data;
    return await Ut.coalesceAsync(v, async () => {
      const D = zt.ComputeNodeProtocol.encodeDelimited({
        version: s
      }).finish(), O = Fe.Request.encodeDelimited({
        deltaRequest: this.encryptAndEncode(
          new Uint8Array([...D, ...a])
        )
      }).finish(), H = xt.SESSION_MESSAGES.replace(
        ":sessionId",
        this.sessionId
      ), ce = await (await this.api.post({
        endpoint: H,
        headers: {
          "Content-type": "application/octet-stream"
        },
        options: {
          retry: !1
        },
        reqBody: O
      })).arrayBuffer(), ye = Yt.Reader.create(new Uint8Array(ce)), le = [];
      for (; ye.pos < ye.len; ) {
        const we = Fe.Response.decodeDelimited(ye);
        if (we.response === "unsuccessfulResponse")
          throw new Error(`${we.unsuccessfulResponse}`);
        const Ce = we.successfulResponse, Ue = this.decodeAndDecrypt(Ce);
        if (Ue == null)
          throw new Error("Response decryption failed");
        const oe = Yt.Reader.create(Ue), Oe = zt.ComputeNodeProtocol.decodeDelimited(oe);
        if (Oe.version !== s)
          throw new Error(
            `Unsupported protocol version in response. Expected ${s}, received ${Oe.version} from enclave`
          );
        le.push(oe.buf.subarray(oe.pos));
      }
      return le;
    });
  }
  async sendCompilableRequest(a, s, b, v) {
    const U = a(s, this), D = await this.sendRequestRaw(
      U,
      v
    );
    return b(D);
  }
  async sendRequestV2(a) {
    const s = Fe.DataNoncePubkey.encodeDelimited(
      this.encryptAndEncode(Ee.GcgRequestV2.encodeDelimited(a).finish())
    ).finish(), b = be.md.sha256.create();
    b.update($t(s));
    const v = b.digest().data;
    return await Ut.coalesceAsync(v, async () => {
      const D = xt.SESSION_MESSAGES_V2.replace(
        ":sessionId",
        this.sessionId
      ), O = new Uint8Array(
        await (await this.api.post({
          endpoint: D,
          headers: {
            "Content-type": "application/octet-stream"
          },
          options: {
            retry: !1
          },
          reqBody: s
        })).arrayBuffer()
      ), H = Fe.Response.decodeDelimited(O);
      if (H.response === "unsuccessfulResponse")
        throw new Error(`${H.unsuccessfulResponse}`);
      const ce = this.decodeAndDecrypt(
        H.successfulResponse
      );
      if (ce == null)
        throw new Error("Response decryption failed");
      return Ee.GcgResponseV2.decodeDelimited(ce);
    });
  }
  stringRepresentation() {
    return `Channel(sessionId: ${this.sessionId})`;
  }
}
class ht {
  data;
  state;
  constructor(a, s) {
    this.data = a, this.state = s;
  }
}
class er {
  client;
  channel;
  authToken;
  constructor(a, s) {
    this.client = a, this.channel = s, this.authToken = null;
  }
  async setAuthToken(a) {
    this.authToken = a;
  }
  static async create({
    client: a,
    connection: s
  }) {
    return new er(a, s);
  }
  async sendUnauthenticatedRequest(a) {
    const s = Ee.GcgRequestV2.create({
      unauthenticated: a
    }), b = await this.channel.sendRequestV2(s);
    if (b.failure)
      throw new We(b.failure);
    const v = b.success;
    if (v?.unauthenticated === null || v?.unauthenticated === void 0)
      throw new Error(
        `Expected \`authenticated\` response, got ${v}`
      );
    return v.unauthenticated;
  }
  async sendAuthenticatedRequest(a) {
    if (this.authToken == null)
      throw new Error(
        "sendAuthenticatedRequest called without an enclave token. Please use session.setAuthToken()"
      );
    this.authToken.type === "enclave-access" ? a.accessToken = this.authToken.value : a.apiToken = this.authToken.value;
    const s = Ee.GcgRequestV2.create({
      authenticated: a
    }), b = await this.channel.sendRequestV2(s);
    if (b.failure)
      throw new We(b.failure);
    const v = b.success;
    if (v?.authenticated === null || v?.authenticated === void 0)
      throw new Error(
        `Expected \`authenticated\` response, got ${v}`
      );
    return v.authenticated;
  }
  async sendAuthenticationRequest(a) {
    const s = Ee.UnauthenticatedRequest.create({
      authentication: a
    }), b = await this.sendUnauthenticatedRequest(
      s
    );
    if (b.authentication === null || b.authentication === void 0)
      throw new Error(
        `Expected \`authentication\` response, got ${b}`
      );
    return b.authentication;
  }
  async sendSecretStoreRequest(a) {
    const s = Ee.AuthenticatedRequest.create({
      secretStore: a
    }), b = await this.sendAuthenticatedRequest(s);
    if (b.secretStore === null || b.secretStore === void 0)
      throw new Error(
        `Expected \`secretStore\` response, got ${b}`
      );
    return b.secretStore;
  }
  async removeSecret(a, s) {
    const b = dt.SecretStoreRequest.create({
      removeSecret: {
        expectedCasIndex: s,
        id: a
      }
    }), v = await this.sendSecretStoreRequest(b);
    if (v.removeSecret === null || v.removeSecret === void 0)
      throw new Error(`Expected \`removeSecret\` response, got ${v}`);
    if (v.removeSecret.removed === null || v.removeSecret.removed === void 0)
      throw new Error(`Expected \`removed\` in response, got ${v}`);
    return v.removeSecret.removed;
  }
  async getSecret(a) {
    const s = dt.SecretStoreRequest.create({
      getSecret: {
        id: a,
        version: Ct.SECRET_STORE_ENTRY_STATE_VERSION
      }
    }), b = await this.sendSecretStoreRequest(s);
    if (b.getSecret === null || b.getSecret === void 0)
      throw new Error(`Expected \`getSecret\` response, got ${b}`);
    const v = b.getSecret;
    if (v?.secret?.content === void 0 || v?.secret?.content === null || v?.secret?.state === void 0 || v?.secret?.state === null || v?.casIndex === void 0 || v?.casIndex === null)
      throw new Error(
        `Expected \`secret.content\`, \`secret.state\` and \`casIndex\` in response, got ${v}`
      );
    return [
      new ht(
        v.secret.content,
        Ct.SecretStoreEntryStateSchema.parse(
          JSON.parse(new TextDecoder().decode(v.secret.state))
        )
      ),
      Number(v.casIndex)
    ];
  }
  async createSecret(a) {
    const s = dt.SecretStoreRequest.create({
      createSecret: {
        secret: {
          content: a.data,
          state: new TextEncoder().encode(JSON.stringify(a.state))
        }
      }
    }), b = await this.sendSecretStoreRequest(s);
    if (b.createSecret === null || b.createSecret === void 0)
      throw new Error(`Expected \`createSecret\` response, got ${b}`);
    const v = b.createSecret;
    if (v?.id === void 0 || v?.id === null)
      throw new Error(
        `Expected \`id\` in response, got ${v}`
      );
    return v.id;
  }
  async updateSecretAcl(a, s, b) {
    const v = dt.SecretStoreRequest.create({
      updateSecretAcl: {
        expectedCasIndex: b,
        id: a,
        newAcl: new TextEncoder().encode(JSON.stringify(s)),
        version: Ct.SECRET_STORE_ENTRY_STATE_VERSION
      }
    }), U = await this.sendSecretStoreRequest(v);
    if (U.updateSecretAcl === null || U.updateSecretAcl === void 0)
      throw new Error(`Expected \`updateSecretAcl\` response, got ${U}`);
    if (U.updateSecretAcl.updated === null || U.updateSecretAcl.updated === void 0)
      throw new Error(`Expected \`updated\` in response, got ${U}`);
    return U.updateSecretAcl.updated;
  }
  async createApiToken(a) {
    const s = Ee.AuthenticatedRequest.create({
      createApiToken: { name: a }
    }), b = await this.sendAuthenticatedRequest(s);
    if (b.createApiToken === null || b.createApiToken === void 0)
      throw new Error(`Expected \`createApiToken\` response, got ${b}`);
    const v = b.createApiToken;
    if (v?.token === void 0 || v?.token === null)
      throw new Error(
        `Expected \`token\` in response, got ${v}`
      );
    return v.token;
  }
  async getApiTokens() {
    const a = Ee.AuthenticatedRequest.create({
      getApiTokens: {}
    }), s = await this.sendAuthenticatedRequest(a);
    if (s.getApiTokens === null || s.getApiTokens === void 0)
      throw new Error(`Expected \`getApiTokens\` response, got ${s}`);
    if (s.getApiTokens.tokens === null || s.getApiTokens.tokens === void 0)
      throw new Error(
        `Expected \`tokens\` in response, got ${s.getApiTokens}`
      );
    return s.getApiTokens.tokens;
  }
  async deleteApiToken(a) {
    const s = Ee.AuthenticatedRequest.create({
      deleteApiToken: { token: a }
    }), b = await this.sendAuthenticatedRequest(s);
    if (b.deleteApiToken === null || b.deleteApiToken === void 0)
      throw new Error(`Expected \`deleteApiToken\` response, got ${b}`);
  }
}
function $t(x) {
  let a = "";
  for (let s = 0; s < x.length; s++)
    a += String.fromCharCode(x[s]);
  return a;
}
function lt(x, a) {
  const s = be.hmac.create();
  return s.start("sha512", be.util.binary.raw.encode(x)), s.update(be.util.binary.raw.encode(a)), be.util.binary.raw.decode(s.digest().bytes());
}
function tr(x, a, s, b) {
  s.length === 0 && (s = new Uint8Array(64));
  const v = lt(s, a);
  let U = new Uint8Array(), D = new Uint8Array();
  for (let O = 0; O < Math.ceil(x / 64); O++) {
    const H = new Uint8Array([O + 1]);
    U = lt(v, new Uint8Array([...U, ...b, ...H])), D = new Uint8Array([...D, ...U]);
  }
  return D.slice(0, x);
}
function qt(x) {
  const a = be.md.sha256.create();
  return a.update(
    be.util.binary.raw.encode(
      Bt.AttestationSpecification.encodeDelimited(x).finish()
    )
  ), a.digest().toHex();
}
function hn(x, a, s) {
  const b = Bt.AttestationSpecification.create(a), v = qt(b);
  for (const U of s)
    if (qt(U.proto) === v) {
      const D = U.decoder;
      if (D !== void 0)
        return D.decode(x);
    }
}
function rr(x, a) {
  const s = /* @__PURE__ */ new Map();
  if (x.elements) {
    const b = /* @__PURE__ */ new Map();
    for (const v of Object.values(x.elements))
      v.id && b.set(v.id, v);
    for (const v of Object.values(x.elements)) {
      const U = v.id, D = v.computeNode?.branch;
      if (U && D) {
        const O = D.config, H = D.attestationSpecificationId;
        if (H && O) {
          const ce = b.get(H)?.attestationSpecification;
          if (ce && ce) {
            const ye = hn(
              O,
              ce,
              a
            );
            ye && s.set(U, ye);
          }
        }
      }
    }
  }
  return s;
}
async function xn(x, a) {
  const s = rr(
    x,
    a
  ), b = {};
  for (const v of Object.values(x.elements)) {
    const U = v.id;
    if (U && v.computeNode?.branch && s.has(U)) {
      const D = v.computeNode.branch.toJSON();
      b[U] = {
        ...D,
        config: s.get(U)
      };
      continue;
    }
    U && (b[U] = v.toJSON());
  }
  return b;
}
function ln(x) {
  const a = Math.floor(1.5 * x), s = It.withSize(a);
  let b = 0;
  return new TransformStream({
    flush(v) {
      if (s.size() > 0) {
        const U = s.view(!0);
        v.enqueue({ data: U, progress: b }), s.reset();
      }
    },
    transform({ data: v, progress: U }, D) {
      for (b = U, s.extend(v); s.size() >= x; ) {
        const O = s.view().slice(0, x);
        D.enqueue({ data: O, progress: b });
        const H = new Uint8Array([
          ...s.view().slice(x)
        ]);
        s.reset(), s.extend(H);
      }
    }
  });
}
function pn(x) {
  let a = [];
  return new TransformStream({
    flush(s) {
      a.length > 0 && s.enqueue(a);
    },
    transform(s, b) {
      a.length < x ? a.push(s) : (b.enqueue(a), a = [s]);
    }
  });
}
function nr(x) {
  return new Promise((a) => setTimeout(a, x));
}
function fr(x) {
  return be.util.binary.hex.encode(x);
}
function yn(x) {
  return be.util.binary.hex.decode(x);
}
async function* or({
  total: x = 1,
  backoffFactor: a
}) {
  if (x < 1)
    throw new Error("total must be greater than 0");
  let s = 0;
  for (; s < x; ) {
    yield s;
    const b = Math.pow(2, s) * a;
    await nr(b * 1e3), s += 1;
  }
}
function bn(x, a) {
  const s = lr.intersection(x, a);
  if (s.length === 0) {
    const v = Math.min(...x), U = Math.max(...a);
    let D = `Endpoint is only available with protocol versions [${a}] but the enclave only supports [${x}].
`;
    throw v > U ? D += "Try upgrading to a newer version of the SDK" : D += "Try using an older version of the SDK", new Error(D);
  }
  return Math.max(...s);
}
function wn(x, a) {
  let s;
  if (x.kind === "dataset_key")
    s = new ht(x.value, {
      acl: {
        type: "UsersList",
        users: [
          {
            id: a,
            role: "Owner"
          }
        ]
      },
      manifest_hash: x.key,
      type: "DatasetKey",
      version: "V0"
    });
  else if (x.kind === "dataset_metadata")
    s = new ht(x.value, {
      acl: {
        type: "UsersList",
        users: [
          {
            id: a,
            role: "Owner"
          }
        ]
      },
      manifest_hash: x.key,
      type: "DatasetMetadata",
      version: "V0"
    });
  else if (x.kind === "pending_dataset_import")
    s = new ht(x.value, {
      acl: {
        type: "UsersList",
        users: [
          {
            id: a,
            role: "Owner"
          }
        ]
      },
      data_connector_job_id: x.key,
      type: "PendingDatasetImport",
      version: "V0"
    });
  else
    throw x.kind === "other_secret" ? new Error("Other secret cannot be migrated automatically") : new Error("Unknown secret kind");
  return s;
}
const Tn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  computeHexHashForAttestationSpec: qt,
  createGroups: pn,
  decodeComputeNodeConfigurations: rr,
  decodeDataRoomConfiguration: xn,
  fromHex: yn,
  getProtocol: bn,
  getRetryIterator: or,
  hkdf: tr,
  hmac_sha512: lt,
  keychainEntryToSecret: wn,
  sleep: nr,
  toHex: fr,
  transformChunkSize: ln,
  uint8ArrayToBinaryString: $t
}, Symbol.toStringTag, { value: "Module" }));
export {
  cn as A,
  yt as C,
  vr as D,
  xt as E,
  er as S,
  fn as U,
  bn as a,
  fr as b,
  pn as c,
  We as d,
  or as e,
  yn as f,
  Yr as g,
  qt as h,
  Qt as i,
  wr as j,
  mr as k,
  gr as l,
  Dn as m,
  Je as n,
  sn as o,
  ht as p,
  Tn as q,
  It as r,
  rr as s,
  ln as t,
  $t as u,
  xn as v,
  tr as w,
  lt as x,
  wn as y,
  nr as z
};
//# sourceMappingURL=utils-CTvTB86_.js.map
